{
 "schema": "ft.ability-motion.v1",
 "generatedAt": "2026-10-02T02:04:33.089Z",
 "source": "tools/vfx/class-ability-motion-classify.mjs first pass + one description-read consult (2026-09-25); owner review pending; + ability presentation gap Lane C (2026-10-01): 761 creature/item/child/class-leftover martial abilities — classifier + one description-read Codex pass for untagged and thrown-item rows (plans/ability-presentation-gap-2026-10-01.md); owner review pending; + Lane D (2026-10-01): 179 utility abilities whose per-ability read chose a gesture (use/stance/parry/battlecry/basic) + 1 import presentation stage (2026-10-07: Greedy Smirk, gesture — Dark Gnome haggling contest, Pickpocket precedent); + Short Rest (2026-10-19, owner: no casting animation — `none` = a STILL ability: no gesture, no action pool; its golden heal glow still plays)",
 "motions": [
  "basic",
  "smash",
  "thrust",
  "cleave",
  "whirl",
  "flurry",
  "kick",
  "shove",
  "shield_bash",
  "charge",
  "shot",
  "parry",
  "stance",
  "battlecry",
  "finisher",
  "gesture",
  "weapon_buff",
  "none"
 ],
 "entries": {
  "4DDCB07D-2120-78A7-765E-5231BBB663AD": {
   "name": "Aberration's Roar",
   "type": "ability",
   "motion": "battlecry"
  },
  "5D1E850A-15F8-FD09-2B01-20992932FD76": {
   "name": "Acidic Disarm",
   "type": "ability",
   "motion": "gesture"
  },
  "2ABEF767-D28C-B2C0-DAD4-F375F56CC593": {
   "name": "Adept Channel",
   "type": "ability",
   "motion": "gesture"
  },
  "61352409-D8BE-6D60-D673-065A32AA62EF": {
   "name": "Barrage",
   "type": "ability",
   "motion": "shot"
  },
  "35D8CCED-9552-46E1-AA91-85BE307C4D00": {
   "name": "Battlefield Dominance",
   "type": "ability",
   "motion": "stance"
  },
  "C9812556-424A-10C3-75B8-EEC7BB02FD67": {
   "name": "Bulletstorm",
   "type": "ability",
   "motion": "shot"
  },
  "6FAFDC8F-A0E7-82D8-0F14-639301AE5997": {
   "name": "Challenge the Advance",
   "type": "ability",
   "motion": "gesture"
  },
  "B25B7623-5626-42A7-A133-5C0138D5DF8B": {
   "name": "Challenging Roar",
   "type": "ability",
   "motion": "battlecry"
  },
  "8D5B2497-1FC2-45F0-8DE3-22E6E7923C4E": {
   "name": "Chillcry Howl",
   "type": "ability",
   "motion": "battlecry"
  },
  "F96F282A-C742-354C-B6D1-EDB66813CDF4": {
   "name": "Eight-Sip Eruption",
   "type": "ability",
   "motion": "flurry"
  },
  "B8E20238-848B-A562-09F9-4E0046919DB2": {
   "name": "Harvest the World",
   "type": "ability",
   "motion": "whirl"
  },
  "8D64F1D8-6363-66CD-8534-8ACCCD84C820": {
   "name": "Heartburst Extraction",
   "type": "ability",
   "motion": "finisher"
  },
  "A31EB429-A284-C6D5-D244-0ADD8263FB72": {
   "name": "Hollow Roar",
   "type": "ability",
   "motion": "battlecry"
  },
  "88B3EFB8-89DA-46AF-9269-2792A8A705B8": {
   "name": "Intimidating Shout",
   "type": "ability",
   "motion": "battlecry"
  },
  "84206F4F-6470-3BD9-8BBC-E6C2B41D5D05": {
   "name": "Piercing Round",
   "type": "ability",
   "motion": "shot"
  },
  "0217F567-C2BF-7F05-F2FF-A076A60EFAF9": {
   "name": "Rallying Cry",
   "type": "ability",
   "motion": "battlecry"
  },
  "6E0D79D0-9220-740F-13C6-5C1778CAE97E": {
   "name": "Roar of the Reaver",
   "type": "ability",
   "motion": "battlecry"
  },
  "C751856F-4C89-FCFA-AF85-D75D10755012": {
   "name": "Scarlet Roar",
   "type": "ability",
   "motion": "battlecry"
  },
  "39804300-7D25-A959-9242-4F51EDB1105E": {
   "name": "See the Ending",
   "type": "ability",
   "motion": "gesture"
  },
  "8CAD05EC-1D95-684C-FC9D-5678E1A16F9E": {
   "name": "Seismic Slam",
   "type": "ability",
   "motion": "smash"
  },
  "4B712710-C575-2FBA-EDA0-D15FD97D5FC0": {
   "name": "Shattered Sword",
   "type": "ability",
   "motion": "gesture"
  },
  "7272F3C1-DBE9-6FC9-36C2-97D67DB583F0": {
   "name": "Terror of the Dragon",
   "type": "ability",
   "motion": "battlecry"
  },
  "57FDDD0B-31D4-5CEB-31E3-EDC2CDB4421C": {
   "name": "Thermite Charge",
   "type": "ability",
   "motion": "gesture"
  },
  "AF552AC4-5580-17F6-CFE8-847442F06B94": {
   "name": "Worldburn Engine",
   "type": "ability",
   "motion": "gesture"
  },
  "075B69CB-294F-6390-2E42-6469799530B8": {
   "name": "Arc-Skirmish",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "27DCB538-DBA5-83E6-530B-170EEDE978EC": {
   "name": "Arterial Accuracy",
   "type": "attack_ability",
   "motion": "basic"
  },
  "326CC9EF-66FF-F154-028D-411A642D723D": {
   "name": "Assassination Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "141DEF36-F315-AF1B-790E-FDA644F20371": {
   "name": "Back Kick",
   "type": "attack_ability",
   "motion": "kick"
  },
  "4EDF14B7-8523-74D6-9858-C9225D2623DD": {
   "name": "Backstabber",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F828010F-C807-ACE2-F795-32C713582366": {
   "name": "Backstep Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B0ABF374-CD4F-4F0F-8FFE-C0E95AA94002": {
   "name": "Bakuretsu Hyakuretsu Ken",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "01E2690E-169D-460A-97FD-AE7A4D95AEA5": {
   "name": "Between The Eyes",
   "type": "attack_ability",
   "motion": "shot"
  },
  "CE621499-40B7-810D-BA1C-CEDE270B4FC6": {
   "name": "Blade Feint",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D89CA52F-A9FF-4DA2-BE8C-977A73EE3C43": {
   "name": "Blade Twist",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "B2614CE6-3BB5-A540-A3C5-F9DD449C819D": {
   "name": "Blinding Combo",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "8D168EF0-AD2E-EB46-5191-9652AAB7F22D": {
   "name": "Blood Let",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AA8359AE-3FCE-7A9B-2B04-1941D8FFBBDD": {
   "name": "Bloodspike Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4DEA68A0-C31C-B3FA-318A-B91C71CE08FB": {
   "name": "Blooming Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5534C15E-E88C-ECED-12D8-BCF5A0A464C1": {
   "name": "Bottom Brick",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B45D0083-3A3D-5536-93DF-1E47EC5C2189": {
   "name": "Breath-Stopping Touch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7FD4096D-67D5-B26E-CBF9-E3269C037480": {
   "name": "Bristling Elbow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F532A052-0D72-4F0F-BB49-CA7E9F02AC0E": {
   "name": "Buckle Powerbomb",
   "type": "attack_ability",
   "motion": "shove"
  },
  "5E5BD040-D0D7-96B0-2B70-2485E10152AF": {
   "name": "Chrono Execution",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5A6380AF-6F69-4801-B634-8D3F7CBC5308": {
   "name": "Chui Touch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "542132EB-731E-256D-8BB3-C94F9B968CD4": {
   "name": "Cleaving Attack",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "0A0F67A2-2746-12E7-8268-46F039018343": {
   "name": "Close Quarters Blast",
   "type": "attack_ability",
   "motion": "shot"
  },
  "A8E94FB1-3F77-8811-5DBC-3F9C4C720B51": {
   "name": "Clothesline Strike",
   "type": "attack_ability",
   "motion": "charge"
  },
  "14AB0EDF-2DD1-46EB-A927-2CC11F832061": {
   "name": "Cloverleaf Grapple",
   "type": "attack_ability",
   "motion": "shove"
  },
  "61B8B747-9CEB-42D8-AEE0-DDAD10554C45": {
   "name": "Crimson Tide Cutlass",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "AFD03367-E800-77E8-B6C6-7EF1B6CFD0E9": {
   "name": "Cripple",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A8D8C8B0-3CB7-2C2F-AC84-C49F004F8E22": {
   "name": "Crippling Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "23327C02-D6C2-5CCD-0B8B-B13632CB85BE": {
   "name": "Cyclone Spin",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "ABF53974-A4A9-0F3E-E4A4-B4E7885D10A6": {
   "name": "Dance of Eight Legs",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "B5EA64DA-6B37-C40E-6050-4860F1B93EBE": {
   "name": "Dazing Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "F29BB85E-90FD-260A-94BF-F4A3337658E6": {
   "name": "Death Spiral",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "B7A0D4F2-B265-F7A2-EEF2-D362265A1841": {
   "name": "Decimate",
   "type": "attack_ability",
   "motion": "smash"
  },
  "93AB5437-71E0-CA91-AF0E-5AEBC3104AD6": {
   "name": "Deep Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "FAF1157E-FC2C-047D-D981-846D0AC710DB": {
   "name": "Determined Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1D8C3617-9493-0A53-17A1-6180BD85494D": {
   "name": "Devastate",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "7367F1C7-A127-5511-207F-D6B23179513E": {
   "name": "Dilation Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D221F9D7-155D-4F94-9765-93CC9460DE32": {
   "name": "Dishonorable Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4153931E-07B4-D690-D3AE-7EB2E77C31EF": {
   "name": "Displacement Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "57CD62D9-82C0-12FE-EEA8-37ACC5FE160B": {
   "name": "Double Edge",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "AF38B658-4169-4953-364F-91C2FF77E858": {
   "name": "Double Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "196448A0-3BC4-4DA3-35CB-8E6856CF7D55": {
   "name": "Effírië",
   "type": "attack_ability",
   "motion": "shot"
  },
  "3B290509-F765-45D8-BD7F-2B1B7B751EBC": {
   "name": "Elbow Drop",
   "type": "attack_ability",
   "motion": "smash"
  },
  "EFB3256C-231A-40FC-97C3-FC62FC199BB4": {
   "name": "Enhanced Shank",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "149547B5-828C-E0F7-C396-AFE3087D246D": {
   "name": "Etchstrike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CBC8224E-F9C4-3A90-069F-F4CDBEC6F41C": {
   "name": "Execute",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "A574E35B-DC4C-A5F2-157F-9391ABA22E94": {
   "name": "Exhausting Crush",
   "type": "attack_ability",
   "motion": "smash"
  },
  "E8EB05AD-619F-ABF9-F62F-3DB6ABE36E77": {
   "name": "Feinting Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "74463827-2F4D-C339-ED46-268C500F653F": {
   "name": "Fensui",
   "type": "attack_ability",
   "motion": "basic"
  },
  "273CB72A-68DB-7E6A-2273-853484BCDDB4": {
   "name": "Ferocious Grip",
   "type": "attack_ability",
   "motion": "shove"
  },
  "BBEBF54E-C1EB-F070-0CE3-2390375A6501": {
   "name": "Finishing Lunge",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "F6741D7F-8601-7099-90CE-80A03DF0C1BF": {
   "name": "Flash of the Flintlock",
   "type": "attack_ability",
   "motion": "shot"
  },
  "AF5B424B-C13C-1F5C-BCDD-B56A45A8BA6C": {
   "name": "Flash Pellet",
   "type": "attack_ability",
   "motion": "shot"
  },
  "ECC0E7A9-5068-CFB9-F8A2-1C93DF8683BD": {
   "name": "Flask Palm",
   "type": "attack_ability",
   "motion": "gesture"
  },
  "195C1C2A-9898-4FEE-AD64-4916BC0D4757": {
   "name": "Flourishing Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2D2A9440-75D5-B6F4-30AD-3ECCA274AD8C": {
   "name": "Frictionless Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "847D91B0-B441-495E-B4A1-8BBEFE9AC9CE": {
   "name": "Furious Hew",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "D67E8920-A9AE-BA12-EA4E-396E8F84FAED": {
   "name": "Gale Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9C5AC75A-A4A2-BF67-14D8-227C7D681CEC": {
   "name": "Gauntlet Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A8B1A3E5-8D57-D2EA-F0ED-F1B28B8B7E40": {
   "name": "Ghost Palm",
   "type": "attack_ability",
   "motion": "basic"
  },
  "12BA949C-B13F-4230-96B2-9B1EDE87FB01": {
   "name": "Giant Swing",
   "type": "attack_ability",
   "motion": "shove"
  },
  "FF043FE6-1B9F-D86D-8602-279B6D3EE451": {
   "name": "Glassblade Judgement",
   "type": "attack_ability",
   "motion": "smash"
  },
  "EB71C992-F6E1-F4BB-879D-4C8A43DC9122": {
   "name": "Glassblade Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4515AB13-4257-FF0D-19AA-F194C8FF4D25": {
   "name": "Gouge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A2BC5C09-2EDE-D5C0-7985-2BA68D05C68D": {
   "name": "Graceful Guillotine",
   "type": "attack_ability",
   "motion": "smash"
  },
  "E7D4DECC-B429-D96A-B874-B82E7933E11E": {
   "name": "Gun God’s Wrath",
   "type": "attack_ability",
   "motion": "shot"
  },
  "CB12D118-DCC7-49E5-9F15-83F1A05C3E72": {
   "name": "Haru no Kaze",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "E2E0ACD2-C1B0-C99F-CFDE-AEFD619CF05D": {
   "name": "Heart-Stopping Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E7F23762-DF56-686E-7EBF-04D552BACA1D": {
   "name": "Heartbeat Flurry",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "4AA67081-FFC4-67D2-6C79-426121C47A16": {
   "name": "Hollow Point",
   "type": "attack_ability",
   "motion": "gesture"
  },
  "6FD7C8F5-B910-3905-BE93-5F4049EBB21A": {
   "name": "Intercept",
   "type": "attack_ability",
   "motion": "charge"
  },
  "1099EC0E-5B29-C23C-5602-5D6F908CFC5D": {
   "name": "Invisible Execution",
   "type": "attack_ability",
   "motion": "basic"
  },
  "83E14960-A4A2-E87D-E067-0C706A834301": {
   "name": "Ji",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4C073B7D-7E84-A3FC-1939-FEC2C506FAA7": {
   "name": "Kiss of Deceit",
   "type": "attack_ability",
   "motion": "parry"
  },
  "0C91D398-1A18-4735-BA30-2FC617F03C6B": {
   "name": "Knockout Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "BB6112E9-5F6B-4877-8E45-326D765C833E": {
   "name": "Leaping Moonsault",
   "type": "attack_ability",
   "motion": "smash"
  },
  "D0F862AB-BBDB-1C59-3936-CA1CADD515B6": {
   "name": "Leg Snare",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1481928D-9C98-511F-33D8-668B35CE8535": {
   "name": "Leg Sweep",
   "type": "attack_ability",
   "motion": "kick"
  },
  "9FC5E298-CFE1-4374-976C-ADA5A366FFEB": {
   "name": "Lixiang Quan",
   "type": "attack_ability",
   "motion": "basic"
  },
  "04C48F22-8B4D-F5CF-BE96-4206DFD9A200": {
   "name": "Lobotomy Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A8DE1465-66EC-BD19-4EA7-9C9FF0F38233": {
   "name": "Melt Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AD0DA82A-35F4-CA5C-BB31-386DC5FCAE86": {
   "name": "Menacing Cleave",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "D00C44D3-5BB1-84FA-A13C-62E9C7B1E6C3": {
   "name": "Menacing Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "410FA6C9-567B-F7EF-7CA5-C754D105D69D": {
   "name": "Mercy Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1635EB77-31A4-AEB3-AF1B-DA5BBBC78156": {
   "name": "Mercy Killing",
   "type": "attack_ability",
   "motion": "shot"
  },
  "775CB634-9E28-E86E-3EB3-B4E34FA2B37A": {
   "name": "Mind-Blind Touch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BFCBBD9E-1900-D224-B27F-0E9B12C21649": {
   "name": "Mocking Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F39F1437-6772-347F-EFDC-E64FC1014303": {
   "name": "Momentum Strike",
   "type": "attack_ability",
   "motion": "charge"
  },
  "96AF9C81-2ED8-4346-1CDE-72F37185BCBD": {
   "name": "Monster Slaying",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0444E82D-0E48-DD9E-2BC7-F17FA0468E9F": {
   "name": "Monstrous Soft Spots",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2036F2CB-E27A-480D-A82C-193A10B25C81": {
   "name": "Neckbreaking Piledriver",
   "type": "attack_ability",
   "motion": "shove"
  },
  "CED5D401-DD23-C522-3DCA-5F2C15389988": {
   "name": "Nerve Cascadev",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "35CA8A15-499A-BAA4-76E3-87BEDA238BF1": {
   "name": "Nerve Chain Lock",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A24AB896-F650-32D5-B943-BCAF460F2621": {
   "name": "Nerve Sever",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "E234B3B2-04E4-3EA4-97F6-F9604AE341AD": {
   "name": "Neuroburn Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7F521E33-5856-49EA-8614-21D64AD246CD": {
   "name": "One-handed Chokeslam",
   "type": "attack_ability",
   "motion": "shove"
  },
  "26900808-CEA7-473F-8296-2C3A86209F87": {
   "name": "Overpower",
   "type": "attack_ability",
   "motion": "smash"
  },
  "D56BDF46-96B3-22E7-1548-0AB53406A521": {
   "name": "Pain Spike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "07A14908-E7B2-C264-B511-AAB9A047D7A2": {
   "name": "Paralysis Dart",
   "type": "attack_ability",
   "motion": "shot"
  },
  "D05B9195-739B-7452-B978-779091759718": {
   "name": "Pathogen Lance",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "C7A936B5-176E-3C89-8FDA-9FE0FABB8D7A": {
   "name": "Phantom Lunge",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "5EE51ADB-1A92-1165-D956-63AE9A91F376": {
   "name": "Piercing Limb",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "F033F5D1-9410-EDDC-6E6E-FDCD6193DD5F": {
   "name": "Predatory Lunge",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "9E6C44D0-B67D-82E2-477F-50277E94AD42": {
   "name": "Preemptive Neutralization",
   "type": "attack_ability",
   "motion": "basic"
  },
  "74DEEE22-4F5E-BC69-28B7-9B2FE63C0796": {
   "name": "Pressure Point Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "36FCD7A9-1C01-1ECC-A1E1-B98A122BFB8A": {
   "name": "Reckless Cleave",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "9F1A498C-053C-2A9D-2597-DE23AF33AC15": {
   "name": "Rend",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DD5225C8-6222-A478-2EEE-C764FAF8B6BF": {
   "name": "Repulsor Blast",
   "type": "attack_ability",
   "motion": "gesture"
  },
  "52DB43FE-92F4-EA34-9F2D-DD8892FE9184": {
   "name": "Revenant Cut",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "4DF42582-3889-7614-8536-777132686225": {
   "name": "Roundhouse",
   "type": "attack_ability",
   "motion": "kick"
  },
  "EA258FE3-97C4-4C10-BE39-E9C658105724": {
   "name": "Running Body Slam",
   "type": "attack_ability",
   "motion": "charge"
  },
  "25E90D30-F2C7-D7AE-E38F-B0F67CCB92E9": {
   "name": "Rushing Wind Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9D85CEC1-EDC2-F416-E805-B0F84EC1261F": {
   "name": "Sap",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7D9ED9DC-83CC-03C0-C9E7-218870230476": {
   "name": "Scarlet Rend",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3A4E0368-E5C5-3569-6468-045C5FA78475": {
   "name": "Second Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "51D0AA88-386E-63DE-4066-6E276D92471E": {
   "name": "Sepsis Shock",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B9BF5CDC-7348-6A91-41E3-150E708E4620": {
   "name": "Sever Resolve",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E7D81537-8DDE-D2C1-8E30-DB92C7C88F1C": {
   "name": "Sever Tendon",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DAE14ABC-514B-D36F-1A52-F8A5DBAFC3EB": {
   "name": "Shank",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "41C69631-A556-5EAB-E7D9-CA8FDC7401AB": {
   "name": "Shatter Rhythm",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "2C7296BB-0519-4869-AD5D-105F0BD448D3": {
   "name": "Shatterguard Bash",
   "type": "attack_ability",
   "motion": "shield_bash"
  },
  "858A58EF-DC91-FB19-A454-207D14EF83A4": {
   "name": "Shield Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "B644A592-9509-45E5-80D6-68ADB026C0CD": {
   "name": "Shield Slam",
   "type": "attack_ability",
   "motion": "shield_bash"
  },
  "53839634-C964-3D46-AB8A-D67B5BDBE112": {
   "name": "Shift",
   "type": "attack_ability",
   "motion": "basic"
  },
  "414C984F-6077-DDC8-18AC-4ED943611F02": {
   "name": "Shoving Strike",
   "type": "attack_ability",
   "motion": "shove"
  },
  "6AA143DA-FB69-494D-9BB9-5B337894AE84": {
   "name": "Shuimian Touch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "08A0E349-E05F-067A-4070-F12A5652B72B": {
   "name": "Silence Net",
   "type": "attack_ability",
   "motion": "gesture"
  },
  "F33C6436-6E17-32FC-34EB-C3AAE572EA3C": {
   "name": "Silencing Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DDF4C348-A754-0A69-A070-1C9BFF0F5837": {
   "name": "Silent Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7567B32D-40B7-5EE9-B377-08B2B41A0EEB": {
   "name": "Silent Palm",
   "type": "attack_ability",
   "motion": "basic"
  },
  "72ECEC6E-EF53-93A5-A525-DAE64509ECC2": {
   "name": "Silken Grip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0776A1A1-8B1D-2ECD-2A7F-7615C8E53572": {
   "name": "Sky King's Ascendancy",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CC548847-AA18-27B5-D00B-B8588FADC812": {
   "name": "Slapstick Swipe",
   "type": "attack_ability",
   "motion": "shove"
  },
  "BCD3C6AA-28F1-FB7B-4E68-9FB8016B28B1": {
   "name": "Sleight Swipe",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3AF2531A-1152-5F90-618F-A73DADDE04EC": {
   "name": "Slice and Dice",
   "type": "attack_ability",
   "motion": "basic"
  },
  "315A89A1-49FF-DA8A-62C9-352E4512603A": {
   "name": "Smothering Attack",
   "type": "attack_ability",
   "motion": "shove"
  },
  "FFA6DF7B-D648-D8A2-4BF9-9C7427E44A77": {
   "name": "Smothering Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "AB305B7C-B34E-08BC-4523-8F09D70769DD": {
   "name": "Soft Hands, Sharp Intent",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3DC563CA-6130-B081-6F05-D63E7DCEDC74": {
   "name": "Speed Erasure Blade",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B4A1EE37-7BBC-ABD1-1F3A-C06D36073BA9": {
   "name": "Spite Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9D683F61-6C38-72A4-3765-88429B16D72B": {
   "name": "Stage Fatality",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "FF8336D7-7029-1455-624B-4219F334BC66": {
   "name": "Staggering Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "5DF03A49-1403-926D-E01B-6E17D3DC98D3": {
   "name": "Stumbling Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "7B087C9C-DBC0-E867-78E6-BDA20769723B": {
   "name": "Sudden Executioner",
   "type": "attack_ability",
   "motion": "smash"
  },
  "120F66BA-E16A-0967-D30B-81C4AF4D2A85": {
   "name": "Suffering Lash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F8027540-40F6-56EE-E282-C45107AD076A": {
   "name": "Sunder Flesh",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6A16A664-B7DA-83E9-8A1E-B27ECBED3307": {
   "name": "Suppression Rounds",
   "type": "attack_ability",
   "motion": "shot"
  },
  "603B6E5F-ECB0-4AEB-B054-892D95401EE8": {
   "name": "Surge Strike",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "9E2DE529-6583-4FB5-9BBC-0410CBBD4C94": {
   "name": "Swashbuckler's Flourish",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B59ABD69-D4FF-A965-4A47-CD1BAFE9A690": {
   "name": "Sweeping Cage",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "E73237C9-56BF-252B-E3C8-9383D3B83172": {
   "name": "Swift Execution",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "EE137092-8136-D46C-69DB-4910EE049A01": {
   "name": "Tactical Cleave",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "35607ABE-C939-8D0C-C9DD-36EF4125CFDD": {
   "name": "Tactical Trip",
   "type": "attack_ability",
   "motion": "kick"
  },
  "356C87C4-2713-0316-31C0-5BB95C77FBF9": {
   "name": "Tempered Leap",
   "type": "attack_ability",
   "motion": "charge"
  },
  "787B4F40-D50E-6804-B97B-31504E563DC3": {
   "name": "Tendon Snap Kick",
   "type": "attack_ability",
   "motion": "kick"
  },
  "7E722C49-1E7E-2BE0-5A23-DCF26536FE63": {
   "name": "Throat Stab",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "1F995900-BC43-D7B6-34D5-C9D9B0C1579C": {
   "name": "Throatbreaker",
   "type": "attack_ability",
   "motion": "basic"
  },
  "85986678-B583-A8CD-D5BD-BA22B7E8A30D": {
   "name": "Trappers Advantage",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F3B37981-5D47-1882-3CFF-8A25778D3AC0": {
   "name": "Tyrant’s Reaping",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B4130BDC-8231-ED89-90D9-5B4F719A9B41": {
   "name": "Unerring Blade",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "686AE073-A9A0-D821-1CA7-81177604088F": {
   "name": "Unspoken Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CF3B707C-2D01-9DC8-4F5E-00E7BF83E7AD": {
   "name": "Vaulting Assault",
   "type": "attack_ability",
   "motion": "charge"
  },
  "81C661ED-4EBD-C0D7-3527-1F7E70607B68": {
   "name": "Veinburst Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2C30453E-7BDF-4121-9EC2-96FF7C7044EB": {
   "name": "Vengeful Rebuke",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F72E8D6F-68D0-BAF5-395E-F45E0051D5C2": {
   "name": "Vertical Suplex",
   "type": "attack_ability",
   "motion": "shove"
  },
  "0B5C3D5E-6D8C-6553-6C1B-1E61DDF4C2CB": {
   "name": "Vital Jab",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "2BA13CA2-4222-74A5-3FD2-0E8D724900B7": {
   "name": "Vorpal Slash",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "0F87CCDA-7B8D-4A80-8DF7-EA8226E21F2E": {
   "name": "Wangchuan Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "68AF4ECC-3C11-7154-DF01-E6139FD1F0AD": {
   "name": "Whirlwind",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "20233563-5FC2-F75C-5986-EE73B982A74E": {
   "name": "Widow Queen’s Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0F9EB0DD-CF5B-3877-E2D6-89E696750E05": {
   "name": "Wind Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CD232BFA-2619-40A4-8559-11531EF62F99": {
   "name": "Wing Clip Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A638E837-F47A-C66B-1AFF-6AB131AF7BD2": {
   "name": "Wounding Jab",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "84D61538-5B6E-3443-B32C-301EE446A3DA": {
   "name": "Xuan",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "B7B2525A-5667-44FB-8C73-1C7243C14138": {
   "name": "Adrenaline Rush",
   "type": "free_ability",
   "motion": "gesture"
  },
  "C54B661B-15EF-4200-020D-B7525899A807": {
   "name": "Aerial Supremacy",
   "type": "free_ability",
   "motion": "basic"
  },
  "DA322BB9-B6AB-80F4-6A48-387776C48433": {
   "name": "Dead Man’s Gambit",
   "type": "free_ability",
   "motion": "shot"
  },
  "A9D85643-F374-8A48-5CF3-B5739CB2A85E": {
   "name": "Fervorous Rush",
   "type": "free_ability",
   "motion": "gesture"
  },
  "A0A2B028-154A-8C1A-C7E7-7AAF3ACA6285": {
   "name": "Inspiring Rally",
   "type": "free_ability",
   "motion": "battlecry"
  },
  "B9A12CFF-49F3-427B-A616-90265FD29C6A": {
   "name": "Mortal Aim",
   "type": "free_ability",
   "motion": "stance"
  },
  "66168E15-AE00-EE22-9CCF-48DC33E0B250": {
   "name": "Precision Overdrive",
   "type": "free_ability",
   "motion": "stance"
  },
  "AB450B04-6DE4-6424-F29C-E488941E5EF0": {
   "name": "Rallying Presence",
   "type": "free_ability",
   "motion": "stance"
  },
  "CB91252B-E2C7-43D7-B46B-9E5F7BEF7FD4": {
   "name": "Rapid Reload",
   "type": "free_ability",
   "motion": "gesture"
  },
  "E4C4CCE6-CA59-474B-B7AE-231041D67970": {
   "name": "Aimed Shot",
   "type": "full_ability",
   "motion": "shot"
  },
  "126F6A7B-1766-8C55-FB33-DEFE02488844": {
   "name": "Brushstroke Guard",
   "type": "full_ability",
   "motion": "gesture"
  },
  "F55CCD27-A770-A3C0-0AF5-B01C1BD4C978": {
   "name": "Final Hundred Strikes",
   "type": "full_ability",
   "motion": "flurry"
  },
  "10CE5272-11AE-14FE-457E-23A0EB2E737C": {
   "name": "Major Channel",
   "type": "full_ability",
   "motion": "gesture"
  },
  "3C034548-5CBD-B615-FFE1-FBCF98063B1D": {
   "name": "Shatter",
   "type": "full_ability",
   "motion": "gesture"
  },
  "F6B5FCA8-21AE-482E-B827-47A3F657EA6E": {
   "name": "The Legend Still Stands",
   "type": "full_ability",
   "motion": "gesture"
  },
  "E6A4B4A1-9F4C-C442-1232-700628877C1C": {
   "name": "Tidewrought Avatar",
   "type": "full_ability",
   "motion": "gesture"
  },
  "7C989FBB-6850-1CFF-ECEC-3D7258CB0B47": {
   "name": "Boot Knife",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "0CF5D0B9-7738-E7B3-9EA8-26FFDAA20C1D": {
   "name": "Counter Critical",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "E011BDF1-AA95-3B18-2A50-4DA438195D09": {
   "name": "Counterattack",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "2E506FA6-64A8-02D3-E93A-EE260CC4C373": {
   "name": "Deceptive Strike",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "548C7471-1306-7BC3-73BA-443301E5E6BF": {
   "name": "Double Tap",
   "type": "opportunity_attack_ability",
   "motion": "finisher"
  },
  "CDE8C483-6422-6BA1-EE2D-F28F06EE10AE": {
   "name": "Double-Joint Assault",
   "type": "opportunity_attack_ability",
   "motion": "flurry"
  },
  "E652A349-0F64-D910-80F3-651044A2821D": {
   "name": "False Surrender",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "E858A46B-A0E9-77F0-BC4C-0AEB8B4D02BF": {
   "name": "Iron Recoil",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "3545FD2F-2D55-9C9A-50B4-A7D25A763853": {
   "name": "Parry Riposte",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "AB4E622B-A899-B20A-DF38-A1C2D12B3A68": {
   "name": "Ready Rebuttal",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "D259F0A1-2B36-2E7C-4D16-DB2DFD5F0BAB": {
   "name": "Revenge",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "02945F99-E6E2-5710-CC64-3CD9932DC17A": {
   "name": "Sky Sentinel",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "7D5D5D6E-C8F2-90CD-F75B-9B66937F537A": {
   "name": "Step Denial",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "11F3B9DE-CECE-982A-488A-44BF4C3E29C8": {
   "name": "Sync Attack",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "60F654DD-0FBD-CBF1-F15B-8E608EEA5239": {
   "name": "Tipsy Tumble",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "E1DC85CD-E266-D435-33FD-44BDCBEB1DD9": {
   "name": "Unyielding Presence",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "1E062F36-8F72-D04B-AB7C-30D83F101371": {
   "name": "Adrenal Burst",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "4486ABBC-17AD-AE7A-2FC9-06D3C04B316C": {
   "name": "Bloodlight Howl",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "8DAF934A-4150-4456-B5DE-5216747244D4": {
   "name": "Brace for Impact",
   "type": "quick_ability",
   "motion": "stance"
  },
  "96FDEC65-0687-BCA0-DF70-84CDF53FAE21": {
   "name": "Break the Chains",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "BFD4D8FB-7E03-4538-A38A-37A0CA1B7A1E": {
   "name": "Critical Shots",
   "type": "quick_ability",
   "motion": "stance"
  },
  "71D1705D-5A85-6F05-12DB-4886619A8BA7": {
   "name": "Demoralize",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "84440CFB-CB3B-EB86-14B7-49352808075E": {
   "name": "Dragoon's Challenge",
   "type": "quick_ability",
   "motion": "thrust"
  },
  "40921C46-E98B-368B-F1CA-45D7467117BA": {
   "name": "Eagle Eye",
   "type": "quick_ability",
   "motion": "stance"
  },
  "66A60186-0533-E231-DC86-4E602BE4D39F": {
   "name": "Fury Airburst",
   "type": "quick_ability",
   "motion": "basic"
  },
  "DB3C3D4A-DB9A-BB85-21B2-47ACE4E46DE8": {
   "name": "Juggernaut Brace",
   "type": "quick_ability",
   "motion": "stance"
  },
  "1499146D-0D11-47FF-8EF0-C7EFEFDF9475": {
   "name": "Kasumi no Kamae",
   "type": "quick_ability",
   "motion": "stance"
  },
  "5C44F4C0-359A-23BD-96AE-84AB5BCC0F9B": {
   "name": "Kill Shot",
   "type": "quick_ability",
   "motion": "stance"
  },
  "8742D854-5372-9EDE-1930-F7D047824259": {
   "name": "Lashing Vine Kick",
   "type": "quick_ability",
   "motion": "kick"
  },
  "25E7CE52-77F1-82CD-73E6-1F1C1FC1B139": {
   "name": "Minor Channel",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "1290B40B-D3D7-46FB-B587-4DEBC9EDB466": {
   "name": "Mocking Shout",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "5CA989F6-B46A-06A6-3E62-FBDBFAA0F2FB": {
   "name": "Omen",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "C0299271-4C5F-7D1D-E2AF-74454C666407": {
   "name": "Orbital Guard",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "34400BC7-5A4F-5A06-5E7A-9A597AD85E31": {
   "name": "Play Fate Card: Eclipse of Destiny",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "BFB2F902-82BB-73E5-528C-D0936A02D40D": {
   "name": "Play Fate Card: Treasury of Dreams",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "6D7F79BD-17D0-F6DE-40DD-DA5B61AACBDE": {
   "name": "Point of the Spear",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "4BE3111D-23D2-45C8-BFE6-4EA815D1657E": {
   "name": "Precision Shooting",
   "type": "quick_ability",
   "motion": "stance"
  },
  "DE94CFEB-DFE0-9E89-74A8-0C50171F16AA": {
   "name": "Reinforced Vigor",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "12963A49-B451-EE7B-DC8E-4A594A2F66A9": {
   "name": "Reliable Aim",
   "type": "quick_ability",
   "motion": "stance"
  },
  "A1C6D269-80CC-D0F5-8FCB-AD64353C4FEB": {
   "name": "Sai",
   "type": "quick_ability",
   "motion": "stance"
  },
  "C9DD035C-622A-8F70-2F2D-6EB293429B87": {
   "name": "Salvo",
   "type": "quick_ability",
   "motion": "shot"
  },
  "74BA40B9-29F9-18CC-D985-109653252C60": {
   "name": "Seismic Palm",
   "type": "quick_ability",
   "motion": "smash"
  },
  "06D0F6B1-9C14-D7B2-3E27-533EA3BC7962": {
   "name": "Siegebreaker's Roar",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "982EA266-76E1-83AD-0941-FAD77D053519": {
   "name": "Sonic Buffer",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "30B89CD6-BE19-4F5F-8746-BE00C6809613": {
   "name": "Switch to Beijxing Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "D303841A-5D49-A270-453C-E6CA599CFF8D": {
   "name": "Switch to Blooming Fang Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "2077173E-B32E-9082-6964-D1755EB3D6F4": {
   "name": "Switch to Courtesan Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "2765B279-B090-1AB5-CD1C-5459B6ABF7EB": {
   "name": "Switch to Dragon Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "79EE1DDC-65DB-91F6-1D55-F682039B15AF": {
   "name": "Switch to Drunken Master Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "5D5D3042-A422-7176-2143-09153F04DFF6": {
   "name": "Switch to Huo Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "D2FDD710-8D60-2587-93DD-8D900F4882F5": {
   "name": "Switch to Pain Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "85156AE3-AB08-B76C-CB36-7F306D8058A5": {
   "name": "Switch to Puppet Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "4A9E4871-20F6-5001-3A6B-8B3A25D5D806": {
   "name": "Switch to Shizen Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "3040341D-5A3E-68FD-E7BB-BA4C259709A8": {
   "name": "Switch to Shu Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "981F4754-695C-3027-77DC-090C12141E08": {
   "name": "Switch to South Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "CB96E165-0DDC-361F-4023-CA96350DFA16": {
   "name": "Switch to Spider Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "7CC1FCE1-D77B-41EF-B3F2-BA44DA2F5667": {
   "name": "Switch to Wenhe Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "F6D112F7-BBF0-40CA-B311-F447EC79553E": {
   "name": "Switch to Yun Stance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "9117C43F-1D62-0827-C779-33D1BE42C82B": {
   "name": "Taunt",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "39EDFB77-1450-9D73-E5D7-80F9A495B44C": {
   "name": "Tripline Snap",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "3FD7B9B4-5D54-0839-1387-B99E3E77065B": {
   "name": "Adept Defiance",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "1E69CB2C-F4FD-8FE5-83E5-BB358D1FA091": {
   "name": "Already Seen",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "A9EDA3F6-7DA9-3FB9-A4A2-05C74FFC5695": {
   "name": "Blade Anchor",
   "type": "reaction_ability",
   "motion": "thrust"
  },
  "90BE17E8-ECA3-87B5-4E8A-FBEFB14806A8": {
   "name": "Escape Artistry",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "EEAB88B3-C0F6-F5A8-822D-D56B79C8766F": {
   "name": "Grave Guard",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "47B1AA08-4D50-BF36-711D-2E12B2F75703": {
   "name": "Hoodwink",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "D91E0E46-9946-DE42-7A2A-2DE386002275": {
   "name": "Major Defiance",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "DCA42E0E-FDD6-9AE6-5CEE-D579EA7C034E": {
   "name": "Marionette Motion",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "8C78C587-EC9C-9424-D77A-F7B0579ECF93": {
   "name": "Perfect Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "82CE02B9-BBB1-413C-8D4F-01F5CBC9A493": {
   "name": "Sniper Repositioning",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "ED3C4DD4-ECCA-A6CD-D889-23FC351303F0": {
   "name": "Tactical Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "47EC25CB-4D04-B2D3-3410-BA380F3A1EA2": {
   "name": "The Perfect Heist",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "99B7DE61-F949-3BBD-A8AF-688F69FE1AD0": {
   "name": "Wind Tether",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "B8445269-5926-03DA-525C-7D268131F8DA": {
   "name": "Bladebound Resurgence",
   "type": "free_ability",
   "motion": "weapon_buff"
  },
  "DA2D1181-F3F8-D28E-4ABA-5D7877D36737": {
   "name": "Deadly Weapon",
   "type": "free_ability",
   "motion": "weapon_buff"
  },
  "0DB72B71-EC86-9BBF-45F8-862CE7420D46": {
   "name": "Aether Piercing",
   "type": "quick_ability",
   "motion": "weapon_buff"
  },
  "98B32C81-57DA-676A-F952-B882D055C71E": {
   "name": "Limit Break: Blade of the Void",
   "type": "quick_ability",
   "motion": "weapon_buff"
  },
  "AEE9BE88-17F7-0144-4DD5-441FC8CEA6EE": {
   "name": "Soulbrand Blade",
   "type": "quick_ability",
   "motion": "weapon_buff"
  },
  "50213054-79FB-7CA3-621A-84566EB867A0": {
   "name": "Toxic Coating",
   "type": "quick_ability",
   "motion": "weapon_buff"
  },
  "D8B88BB8-FCF6-CA98-B08A-8FF9B0559D90": {
   "name": "Disarming Attack",
   "type": "attack_ability",
   "motion": "shove"
  },
  "6883A403-4E23-426B-9E72-D3391E6FC515": {
   "name": "Aggravating Attack",
   "type": "attack_ability",
   "motion": "battlecry"
  },
  "EE16402D-C286-529B-5EAC-23CA43B7666D": {
   "name": "Menacing Attack",
   "type": "attack_ability",
   "motion": "battlecry"
  },
  "897AE132-16DD-1457-0ACD-A7DB83C08355": {
   "name": "Holstered Throw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B33B76A8-439C-F18F-1BE0-FEF13D820F59": {
   "name": "Riposting Opportunity Attack",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "FD0EBB3B-91A3-D7E6-0DEF-BB57DB04312D": {
   "name": "Sweeping Attack",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "B2531EE3-B111-056A-C46A-107B40B838B9": {
   "name": "Daern's Instant Fortress Summon Attack",
   "type": "ability",
   "motion": "basic"
  },
  "E9968D54-1F06-E9C1-6F6D-90743AFC9112": {
   "name": "Wing Whirlwind",
   "type": "ability",
   "motion": "whirl"
  },
  "6745622F-A0DD-3C38-A97E-485DC6D89B86": {
   "name": "Repulsion Breath Weapon (30)",
   "type": "ability",
   "motion": "basic"
  },
  "297B5E34-1D21-F1B5-2FC5-6C8BCBE7CC78": {
   "name": "Elemental Whirlwind",
   "type": "ability",
   "motion": "whirl"
  },
  "C3B955C3-ADD3-657F-B1D8-69298D019CAA": {
   "name": "Surprise Attack  (2d6)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0F77FF3B-882E-1F39-4B56-F022654E0DEC": {
   "name": "Bulette Deadly Leap",
   "type": "ability",
   "motion": "charge"
  },
  "817E83FF-ECF4-895B-C9FA-E97C1E267802": {
   "name": "Charge (30ft) (3d6)",
   "type": "attack_ability",
   "motion": "charge"
  },
  "7094E5E2-F710-794A-767D-867C8C72CA34": {
   "name": "Fling",
   "type": "quick_ability",
   "motion": "shove"
  },
  "01C8394D-7208-D608-F9D0-FCF4AE2E46C7": {
   "name": "Surprise Attack (3d6)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "68AB7470-8456-3D3D-8B62-0E7DACCEA3AB": {
   "name": "Water Elemental Whelm",
   "type": "ability",
   "motion": "shove"
  },
  "DBC66E16-38EB-A99C-6A4C-7E9C03FA21F1": {
   "name": "Killing Rampage",
   "type": "attack_ability",
   "motion": "charge"
  },
  "1748D6C1-B6A7-3A75-FEF0-3C505442A46C": {
   "name": "Shield Bash (2d4)",
   "type": "attack_ability",
   "motion": "shield_bash"
  },
  "35B4D5CD-197D-4E3C-F3B7-95F14D179089": {
   "name": "Squash (6d6)",
   "type": "quick_ability",
   "motion": "smash"
  },
  "3F5E6E08-34B8-F75B-4CDF-B67974D6C26A": {
   "name": "Martial Advantage",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D8528CF4-243C-62F4-1767-C640743D994A": {
   "name": "Tail Spike",
   "type": "quick_ability",
   "motion": "basic"
  },
  "24A6D719-AECC-B65B-F8FD-BB8AFE021789": {
   "name": "Constricting Attack, Adept",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B3766156-216F-7352-3112-B2D26215F16C": {
   "name": "Damaging Attack (d8)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C0ECF464-6534-29FC-28FF-D7BED9329050": {
   "name": "Poltergeist Telekinetic Thrust",
   "type": "ability",
   "motion": "thrust"
  },
  "E747736F-6550-A1D6-72D2-8DCD361F32D3": {
   "name": "Swallow",
   "type": "attack_ability",
   "motion": "shove"
  },
  "07F8E737-2C37-A02F-D663-5FA58FB2F739": {
   "name": "Rolling Rock",
   "type": "ability",
   "motion": "gesture"
  },
  "F017C9CC-95C5-E85D-E0D7-979693AEFE28": {
   "name": "Lycanthropic Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "371E8321-C982-56FA-3D72-7ACB521E9C5E": {
   "name": "Charge!!",
   "type": "attack_ability",
   "motion": "charge"
  },
  "628EBE0B-9956-7C8E-242C-62298E99D2ED": {
   "name": "Slamming Hit",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0986910F-53EC-A4A0-1B78-86E9FA86E4F0": {
   "name": "Head Smash",
   "type": "attack_ability",
   "motion": "smash"
  },
  "DFDB153C-133A-F367-A7B9-845A3CDA4A03": {
   "name": "Relentless Orc",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "C5D1A6D6-A945-A805-EF13-2B5140264806": {
   "name": "Orcish Brutality",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0519771C-47E3-AAC2-1069-C7C57FD030A0": {
   "name": "The Two Step",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3DF589EE-F971-E94F-83FC-2CF1A7AEE8C8": {
   "name": "Sentinel Protector",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "08759253-B03F-BDFB-D8D1-E2A296CCBD77": {
   "name": "Sentinel Hamstring",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "190A0F5A-255B-E7F1-47EC-C6C84F087CBE": {
   "name": "Hamstring Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "57CA60A6-5B91-91ED-EEF8-D61EBC2D39ED": {
   "name": "Heavy Swing",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BBFA8D29-539A-646C-D960-E506BC90978B": {
   "name": "Feral Swarm",
   "type": "ability",
   "motion": "basic"
  },
  "3888BBD0-62A8-2C76-33AA-A9CA365AEBC8": {
   "name": "Dangerous Grappler",
   "type": "attack_ability",
   "motion": "shove"
  },
  "F72A8C70-70DD-4534-10F7-BC0FE4FDBF4B": {
   "name": "Arcing Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "197A0A76-3077-0BD8-68EA-46B3ABB659D3": {
   "name": "Short Draw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AD60F43C-B0AD-2580-6D05-36373289CCDF": {
   "name": "Close Quarters Combat",
   "type": "opportunity_attack_ability",
   "motion": "shove"
  },
  "E1709CCA-AF0F-9ECC-258E-B44E75314C95": {
   "name": "Shield Shattering Blow",
   "type": "attack_ability",
   "motion": "smash"
  },
  "62A8CDF7-7171-01F1-BEC6-C25B140B30A9": {
   "name": "Trip Attack",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "9FF4D2FE-DE0E-340D-109C-FBC710CD74A8": {
   "name": "Rebuff",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7BDBD7B6-D3BB-59AD-6367-7F76AA8DAC93": {
   "name": "Knight Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "7A75570B-31B1-37C1-AB06-97C22ADB1453": {
   "name": "Repel Charge",
   "type": "reaction_ability",
   "motion": "charge"
  },
  "E585C2AE-EBAA-9EEA-48ED-A4A5D62C8A3C": {
   "name": "Leaping Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A785CA9F-747E-6026-2CB6-D05D07091E19": {
   "name": "Toe Stab",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "D9138F9E-95BF-67F9-CF05-C0E01C13DD75": {
   "name": "Blackjack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9952A545-45DB-2269-D639-BF0B1317BCC1": {
   "name": "Chain Garrote",
   "type": "attack_ability",
   "motion": "shove"
  },
  "2D83EDAC-09BF-F9C4-CE89-0C472C5CCD69": {
   "name": "Shield Snare",
   "type": "attack_ability",
   "motion": "shove"
  },
  "1534B16A-C953-7FF5-F2DD-5C806CB5B072": {
   "name": "Hurling Impact",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E333CA00-9592-0DC4-A890-7C7F6935342F": {
   "name": "Ribshatter",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5EC3C805-FB4F-40AE-6694-80B591D51BEA": {
   "name": "Bruising Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7FAC1993-3300-82C2-160E-E779F685D8AC": {
   "name": "Crippling Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "05BE9BC6-6A38-B4DB-0358-DE07583440F1": {
   "name": "Sundering Strike",
   "type": "attack_ability",
   "motion": "smash"
  },
  "AD3412F3-C331-0367-2F8F-C005E5CAC68C": {
   "name": "Pinning Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "44B1C185-FAC4-0710-8A73-8DD22413EAEB": {
   "name": "Fearsome Accuracy",
   "type": "attack_ability",
   "motion": "basic"
  },
  "97AE17C7-143A-F36C-A4C3-96321BFA5A9B": {
   "name": "Ensnaring",
   "type": "attack_ability",
   "motion": "basic"
  },
  "86EE3574-8ADB-A4E8-495C-03ACE32E753F": {
   "name": "Visionweb Snare",
   "type": "attack_ability",
   "motion": "basic"
  },
  "428F433D-D77C-9666-93A2-9D21CC5BB1DA": {
   "name": "Wing-Wrapping Net",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0F3249AA-68EF-355D-CF64-2DEA7FFEECEC": {
   "name": "Rapid Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "23F1F90E-8220-E3D6-0A5E-B29D3BF406A0": {
   "name": "Distracting Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "FD3ADAC1-A4F6-7B89-E369-E7353038BACD": {
   "name": "Tricky Arrow",
   "type": "attack_ability",
   "motion": "shot"
  },
  "A45D055C-B8C6-FA0F-63FB-43BBC87FA2CB": {
   "name": "Underdog Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9A374064-6451-13E1-408B-1E84C5B4F59B": {
   "name": "Headcrack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "19D941AC-E8D3-2CE8-D9F6-325F13A79324": {
   "name": "Lacerating Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8B5E6B62-8305-5385-E185-3F150629ED9C": {
   "name": "Banish the Benders",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "8FF78DEA-2F08-A042-FDDC-C55ACA5D8247": {
   "name": "Long Arm",
   "type": "opportunity_attack_ability",
   "motion": "thrust"
  },
  "E43F90F7-B6AD-F16C-E34E-F42A3AC410AF": {
   "name": "Swift End",
   "type": "attack_ability",
   "motion": "basic"
  },
  "383C6693-1B8B-9BA9-6391-236FE128EBB3": {
   "name": "Ariessian Under Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "90A13E2F-C1F0-0FAA-34A3-E9F78D7D5C8A": {
   "name": "Winds of the Ariessian",
   "type": "ability",
   "motion": "cleave"
  },
  "B127D8F3-5FA7-0AA9-2756-D9DEEAEA0D4C": {
   "name": "Armament Prowess",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2C4D41BC-6F56-F587-763E-612E83F595AA": {
   "name": "Charging Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CEE55469-454D-0ABF-3DA9-8CE1A908016F": {
   "name": "Goring Rush",
   "type": "attack_ability",
   "motion": "charge"
  },
  "EDC394B7-9AC5-D65E-5EEA-3108ADA9FF6D": {
   "name": "Contemptuous Kick",
   "type": "quick_ability",
   "motion": "kick"
  },
  "257CB8DF-0E03-1F00-F508-265B260589F7": {
   "name": "Crushing Hug",
   "type": "attack_ability",
   "motion": "smash"
  },
  "F27E7803-A584-498A-9F3E-8CB69170E098": {
   "name": "Ruthless Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "002CED60-D977-4652-B67F-9D87DA83930D": {
   "name": "Heavy Weapon Mastery",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "114B5F03-6614-2C71-0CDB-9713ADCCA2E8": {
   "name": "Charge (30ft) (1d6)",
   "type": "attack_ability",
   "motion": "charge"
  },
  "88589A54-B87B-08C1-A93D-637B5C30D50D": {
   "name": "Stomp of the Hill Giant",
   "type": "reaction_ability",
   "motion": "kick"
  },
  "13D541E3-C16C-476C-A115-354716275C1C": {
   "name": "Wild Attack of Thorns",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2131BD10-CA1A-34CD-4DB0-C24F2080D6B9": {
   "name": "Ensnaring Whip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BC4E6871-E59D-47C1-ADC0-5EC70EA76435": {
   "name": "Body Crush (6d20)",
   "type": "ability",
   "motion": "thrust"
  },
  "7E109EDA-FA7C-4FB4-8B45-6EC7318A0B00": {
   "name": "Frogger Leaping Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D8B7B021-B396-3F45-4575-21F995502A6E": {
   "name": "Viscoelastic Tongue",
   "type": "attack_ability",
   "motion": "basic"
  },
  "19248371-52AA-4562-9C3C-E74816478E14": {
   "name": "Giant Body Slam",
   "type": "ability",
   "motion": "smash"
  },
  "1C7E2A37-B02D-4800-4840-A1E66553F0FE": {
   "name": "Living Metal Fling",
   "type": "full_ability",
   "motion": "basic"
  },
  "29D25B95-3250-1E93-7A8C-9BDB5CCE0B42": {
   "name": "Takedown Strike",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "B6C2AED1-87AD-4AD8-AF40-636D4824D39C": {
   "name": "Pounce Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "FF3615E3-0F83-4B68-9B17-FFA43E336D74": {
   "name": "Paralyzing Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6AE19FD4-DE6D-4465-A291-B784B7FAFA97": {
   "name": "Aqueous Corruption Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "30E84067-EC14-40CA-980A-862AC016CA52": {
   "name": "Restraining Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9BB9E724-21B0-5E50-9293-443F24785C0D": {
   "name": "Chokehold Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6CE79B38-1F5C-40AA-A808-8DB7A762A631": {
   "name": "Ensnaring Attack (Claw)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "078BFE86-F9A4-1E4C-E576-CEF45595E4F3": {
   "name": "Topple Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A9B3E439-DFAC-0354-4149-8E57F3A71AD5": {
   "name": "Stunning Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C2636C38-8DAE-4DC0-B9D7-106C1498846D": {
   "name": "Otyugh Infesting Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "686EA12D-2111-4C97-95D7-8DF61D7E7CE1": {
   "name": "Cleave",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "E0104013-1A37-4081-9450-B330F1646A6E": {
   "name": "Backbreaker",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B29DBF4A-0432-4FA8-831C-E8D6AE0702FD": {
   "name": "Concussive Smash",
   "type": "attack_ability",
   "motion": "smash"
  },
  "47B16134-BFE8-4ADD-A0F2-2B19D56E3C9A": {
   "name": "Flourish",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9DA1604B-D02B-4A8A-8D94-2722BB388135": {
   "name": "Heartstopper Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "71FA52C4-73D7-405B-BC6F-4F5B1DA6AF56": {
   "name": "Mobile Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "B89298E2-174F-470F-A564-1102B94AC338": {
   "name": "Piercing Shot",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "597D302B-DC37-D6BE-29CC-D02B820659DB": {
   "name": "Piercing Strike",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "7E52CDBD-3D10-4D69-B4A9-EEE04B1E9543": {
   "name": "Pommel Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CDA19ADF-CE71-A440-6C63-63522B5E407D": {
   "name": "Toppling Attack",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "6B981367-CF55-40D5-99DF-FA8031B3C433": {
   "name": "Hand Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F508A090-2429-465F-B5E4-470D5ACF8235": {
   "name": "Stabby Stabby",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "3A668CEB-F4D8-4A33-9E47-F7EE38CE1A99": {
   "name": "Skulkers Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AFE6AA10-E9E3-4BBB-9E02-2F55CEBAEB41": {
   "name": "Destabilizing Attack",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "71480D4A-E844-49C7-837A-0D7118451383": {
   "name": "Moderate Wounding Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "63F5D527-694F-4E6C-A08E-071886904811": {
   "name": "Tossin' Time",
   "type": "ability",
   "motion": "shove"
  },
  "975B62A7-E1BC-43DE-BBCE-AFC71F9CD8D6": {
   "name": "Hoof Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B4D0D41D-201C-4536-9CA7-3288975F7765": {
   "name": "Dizzying Gore",
   "type": "attack_ability",
   "motion": "charge"
  },
  "12590881-303B-4F69-8533-BF0C37D26716": {
   "name": "Charge of the Horned Warrior",
   "type": "attack_ability",
   "motion": "charge"
  },
  "13DB004B-A3F4-418E-A274-FD8039BA4756": {
   "name": "Withering Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0AA1DDE0-3D31-4E83-B627-C1AB04C461F8": {
   "name": "Petrifying Stirke",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E2F6A0F3-4009-45AA-B3E9-952065DA379E": {
   "name": "Celestial Slaying Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A2E10760-8519-43FB-B6D8-BF2B97FE90CB": {
   "name": "Pixie Poison Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1CF0AB25-6C78-4711-B73F-2193FBA9C1A4": {
   "name": "Minor Poison Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3E1E430E-102E-4BF6-9889-78CA62D270B3": {
   "name": "Spriggin Water Jet",
   "type": "ability",
   "motion": "basic"
  },
  "9CDEB864-EB02-4507-BD42-36E341FE7D77": {
   "name": "Death Frenzy",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "4D7AFDE3-ECE7-4EF5-9755-4228CD5C365F": {
   "name": "Festering Rat Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7A6A05E8-4374-4DC1-91D2-D47B5406E789": {
   "name": "Reality Shatter",
   "type": "attack_ability",
   "motion": "smash"
  },
  "9E8574D6-A025-4EC1-A8F2-8277D93B0430": {
   "name": "Tengu's Wrath",
   "type": "ability",
   "motion": "flurry"
  },
  "52E7164B-3D26-43E7-8D3A-1F85E3CF3993": {
   "name": "Zombie Fever Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E3086528-8921-4C2B-9950-D6E098B9A0E5": {
   "name": "Dispel Evil and Good: Dismissal Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2D189829-5809-489D-8B59-269A630C146F": {
   "name": "Piercing Attack (d6)",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "6E515995-3BB2-20ED-593B-7842F7DA4915": {
   "name": "Poisoning Strike (3d6)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "831C303E-603B-46E1-88B1-AD057FC902CD": {
   "name": "Frightening Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B3D33DEE-4E89-49A3-B005-85281F05F6FA": {
   "name": "Desperate Charge",
   "type": "reaction_ability",
   "motion": "charge"
  },
  "512A5B44-B069-44C1-8350-A7734BE2ECFB": {
   "name": "Bleeding Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "095B4846-74BA-422A-9191-711C3BA156E3": {
   "name": "Oni Slam",
   "type": "ability",
   "motion": "smash"
  },
  "D542F4CF-5937-4CBB-8D22-F68DA6857FAA": {
   "name": "Ground Stomp",
   "type": "ability",
   "motion": "kick"
  },
  "65843875-1101-4720-881C-739894195636": {
   "name": "Acrobatic Barrage",
   "type": "ability",
   "motion": "flurry"
  },
  "7E26DF2B-C7CB-46F5-9926-9FBED9E185BE": {
   "name": "Whirlwind Slash",
   "type": "ability",
   "motion": "whirl"
  },
  "FD794BE3-02D5-457A-86E0-75DCD2E000B2": {
   "name": "Sticky Tongue (Close)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0A0BDCAC-BB65-4225-87FA-C2019C8EA25D": {
   "name": "Death Dog Disease Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2E551ACD-1FE9-4FBD-BB61-8AAD4E2C70CD": {
   "name": "Sleeping Poison Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E5491D8C-0A96-496E-808C-3E8BA61B5CF8": {
   "name": "Blinding Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8D05B266-802F-480E-A83A-32240390196E": {
   "name": "Shred Armor Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EB37CFAD-39BD-4640-9F35-66BD8BE576DF": {
   "name": "Shake Sludge",
   "type": "ability",
   "motion": "basic"
  },
  "097B61D0-E3FF-4BD9-88E4-3A020F3CBE91": {
   "name": "Earth Burst (2d8)",
   "type": "ability",
   "motion": "basic"
  },
  "21BD3EB0-59E4-4C94-8185-E83DBE3B0438": {
   "name": "Burning Strike (d10)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EB363F23-0403-45D1-967F-CFA94F1A7339": {
   "name": "Smoldering Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2A9AEDEB-A673-4C0E-B33E-15650971A452": {
   "name": "Gaia's Wraths",
   "type": "ability",
   "motion": "basic"
  },
  "FA59DB37-B07A-94CD-FEC4-C06A225E64C7": {
   "name": "Burning Strike (d4)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "93D30828-0CB7-CC5E-1B8B-9A164FF79AFB": {
   "name": "Burning Strike (d6)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5809C1A5-56E7-CD29-3C7A-4165423E46F9": {
   "name": "Burning Strike (d8)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4F013F3E-23AA-4A2A-8BDA-C3FDC5ADFD6A": {
   "name": "Corrosive Strike (4d8)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C7787CD8-8073-C73D-33A4-134C435522C3": {
   "name": "Major Wing Whirlwind",
   "type": "ability",
   "motion": "whirl"
  },
  "20577AB7-83FB-98CB-A26E-A0FEA096B53C": {
   "name": "Repulsion Breath Weapon (60)",
   "type": "ability",
   "motion": "basic"
  },
  "C1103C27-942E-406C-B238-3F4DF86DA2AE": {
   "name": "Leaping Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D8FD44F5-EF25-4492-A480-3F951DA5A7CA": {
   "name": "Web Spinner",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "30F94DD1-909A-4E1B-BB45-76E741DB0B23": {
   "name": "Damaging Attack (d4)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A364515E-533F-4001-BAB5-347B4C5BF657": {
   "name": "Damaging Attack (d10)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D4C5D5EE-043E-ED5B-3F84-9B0FCFD30ED4": {
   "name": "Damaging Attack (d12)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CB60C2CE-E71B-8765-0E0C-531639C10F42": {
   "name": "Damaging Attack (d20)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "42477575-CCBC-4426-A092-AC4D70DEFDFF": {
   "name": "Infect (Egg Type)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7262D41B-4ECD-4374-A129-5CE10565E541": {
   "name": "Bloody Proboscis",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7ADEE43D-8A56-47C8-A449-129B4FFD4F6B": {
   "name": "Savage Lunge",
   "type": "ability",
   "motion": "thrust"
  },
  "84C9DF54-467C-433F-9731-627E9C0EEF54": {
   "name": "Exhaustive Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "692D38BC-9318-4342-8061-AE6BBEBF2B4E": {
   "name": "Bounce",
   "type": "ability",
   "motion": "basic"
  },
  "8DB82777-D684-4AD5-ADAA-96FC25BFBF22": {
   "name": "Feather Storm",
   "type": "ability",
   "motion": "basic"
  },
  "A17CE3EA-A82B-4ED3-904B-AEE889015017": {
   "name": "Sky-High Dive",
   "type": "ability",
   "motion": "charge"
  },
  "3F0BD8BA-3D08-4490-BBAD-3669F48B4291": {
   "name": "Precision Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A7A3D130-B4DD-4AD4-9E72-AED57BD59D74": {
   "name": "You Go Squish Now",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "15078A26-EFB3-417D-BAE7-2B4202D894E4": {
   "name": "Shove Attack",
   "type": "attack_ability",
   "motion": "shove"
  },
  "100C9616-B0D6-4D30-A223-9C055E0B0EC7": {
   "name": "Squeak Strike",
   "type": "attack_ability",
   "motion": "shove"
  },
  "D4C58DCF-B986-5EA6-9F79-265FA633B031": {
   "name": "Bulldogs Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3D930C68-6EB7-4065-9604-9CE630D1E734": {
   "name": "Snarl & Bite",
   "type": "ability",
   "motion": "basic"
  },
  "75A526F6-3A25-4A1F-A5A9-2C4B1791EEAC": {
   "name": "Swift Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1059A47F-FF79-4863-8648-28B5BE7138A2": {
   "name": "Toxic Claw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "132726CA-00F9-43E5-9378-BB37EBFA1D3A": {
   "name": "Punishment",
   "type": "full_ability",
   "motion": "basic"
  },
  "17247610-1590-40D5-B13E-853C9BDD4E39": {
   "name": "Meat Hook Binding",
   "type": "ability",
   "motion": "basic"
  },
  "A37DDD40-A68E-3DD7-26BA-691E442CDFA0": {
   "name": "Beast Claw Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3B6AB99F-5405-3287-1F41-AAFA4E8777DA": {
   "name": "Frightening Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7798B69A-21D4-4DB0-8F11-454ADCF6C4B1": {
   "name": "Pinning Javelin",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "9CACFC37-2DC5-235C-1394-ECA2C986F617": {
   "name": "Booze Strike (d6)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "55D33F13-722E-304F-457F-76404458516D": {
   "name": "Booze Breath",
   "type": "ability",
   "motion": "basic"
  },
  "34B9DB65-4570-4EBF-6B6C-633E625D835F": {
   "name": "Booze Elemental Whelm",
   "type": "ability",
   "motion": "shove"
  },
  "C2035EB5-BC59-66D9-23BE-352CCF73D4B5": {
   "name": "Spine Readjustment",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "215F16A3-654E-C09E-F187-7FD4D06C7AA6": {
   "name": "Pouncing Snatch (2d4)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6CEC380E-06AE-4390-A111-228DA8894247": {
   "name": "Gouging Pull",
   "type": "attack_ability",
   "motion": "shove"
  },
  "31A34FC2-EF6E-42D2-A81C-29A44A38CE98": {
   "name": "Poisoning Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BD7D07B7-A5E1-475B-932C-8E9EA6D34ADA": {
   "name": "Reaping Strike",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "24E3149C-9039-4F66-187D-5913A2339DC1": {
   "name": "Grim Reaper’s Reach",
   "type": "opportunity_attack_ability",
   "motion": "cleave"
  },
  "8B543C29-F919-B262-7528-DCF2C013DA0F": {
   "name": "Harvester's Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9DD60CEC-A708-4E33-A762-F3C697DB7E99": {
   "name": "Mantis Slash",
   "type": "quick_ability",
   "motion": "basic"
  },
  "1F3D5DEC-F8D3-4DCA-9A62-546E0BC7C512": {
   "name": "Fan Jian Shu",
   "type": "quick_ability",
   "motion": "basic"
  },
  "68CAA118-DCB7-4426-8E13-D51037B685BF": {
   "name": "Dragon Tail Swipe",
   "type": "quick_ability",
   "motion": "basic"
  },
  "ED12CCD8-AA62-410D-A928-437CB8D8501E": {
   "name": "Wolf Jaw Bite",
   "type": "quick_ability",
   "motion": "basic"
  },
  "622A1B20-1AE7-46A4-9AE9-75EB39407E59": {
   "name": "Wolf Jaw Clasp",
   "type": "ability",
   "motion": "basic"
  },
  "BF82B7B6-D86F-4AB1-AC12-20104CBB134B": {
   "name": "Swirling Branches",
   "type": "ability",
   "motion": "basic"
  },
  "99375970-305D-4E5E-9231-2F49DED6822F": {
   "name": "Clubbing Branch",
   "type": "quick_ability",
   "motion": "basic"
  },
  "71F5418A-F357-4ABE-9B11-54CC4DC8632F": {
   "name": "Cutting Hand Slash",
   "type": "quick_ability",
   "motion": "basic"
  },
  "BF8726C1-4310-4E74-BEF2-D58A73B6E05F": {
   "name": "Lion Claw Slash",
   "type": "quick_ability",
   "motion": "basic"
  },
  "3C4FE8A6-5A7E-489B-816C-84AFC6D25014": {
   "name": "Slumber Enchantment",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1ADC6DFD-385B-4C81-9980-4107809E15D8": {
   "name": "Gale Force",
   "type": "quick_ability",
   "motion": "basic"
  },
  "880A59C4-9C4B-42E3-B590-4F4809D78E1A": {
   "name": "Nature Control (Thorn Briars)",
   "type": "ability",
   "motion": "basic"
  },
  "040219A6-9C37-4E1F-A9FF-79CD7845FED4": {
   "name": "Nature Control (Tree Whip)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "6EF5D33E-45EE-415E-AE97-7F5AF20B87E6": {
   "name": "Nature Control (Restraining Brambles)",
   "type": "ability",
   "motion": "basic"
  },
  "1C0729E1-C669-4373-A3B2-E74FFA83A326": {
   "name": "Planetary Devastation (Vacuum)",
   "type": "full_ability",
   "motion": "basic"
  },
  "39B2E57B-E146-4D10-92BE-98F54B76BEE6": {
   "name": "Planetary Devastation (Falling Debris)",
   "type": "ability",
   "motion": "basic"
  },
  "86DA219D-8657-4C7A-94B9-5E84387739EB": {
   "name": "Planetary Devastation (Flood)",
   "type": "ability",
   "motion": "basic"
  },
  "85C66BC5-7273-4BC4-9018-755C1AA4DC85": {
   "name": "Planetary Devastation (Fall)",
   "type": "full_ability",
   "motion": "basic"
  },
  "801F1AEB-940E-4ACE-ACB1-4D05D18658C5": {
   "name": "Dragon Claw Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E2F258C9-58BA-A38A-ED40-57286587E0DB": {
   "name": "Death Nose Dive",
   "type": "ability",
   "motion": "charge"
  },
  "1B7FDAA6-7B73-4FB9-95A8-2D96E1C0B0E9": {
   "name": "Double Claw Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4665701C-3D25-40C3-B140-242A5FD97691": {
   "name": "Stinger Swipe",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4D48F96B-6F52-44F9-97C6-CDF41A133FB9": {
   "name": "Quill Shot",
   "type": "ability",
   "motion": "shot"
  },
  "3303064D-84DB-42E1-9319-50DBE0046472": {
   "name": "Roll Out",
   "type": "ability",
   "motion": "charge"
  },
  "2FDF6920-F36B-4592-931D-A577D651A91C": {
   "name": "Rat Bodyslam",
   "type": "ability",
   "motion": "charge"
  },
  "F8746EED-24E7-424B-91F2-CDA285AB5309": {
   "name": "Earth Prison",
   "type": "ability",
   "motion": "basic"
  },
  "11C4F548-C0EE-4355-AFF1-264A0AC2B68B": {
   "name": "Rift Quake",
   "type": "ability",
   "motion": "basic"
  },
  "04EFDBB3-E049-4DA3-990B-AB443F2C76D0": {
   "name": "Aqueous Surge",
   "type": "ability",
   "motion": "basic"
  },
  "87C6199D-4346-489A-B7B2-CEFE287130EA": {
   "name": "Crushing Depth",
   "type": "ability",
   "motion": "smash"
  },
  "EFFA5C9A-36E1-4BE4-B722-1B36A320F627": {
   "name": "Maelstrom Core",
   "type": "ability",
   "motion": "basic"
  },
  "348858BE-EF00-4C55-8CE9-7983149BA4D8": {
   "name": "Tsunami Strike",
   "type": "ability",
   "motion": "basic"
  },
  "0B08313E-BEA9-47BD-AD14-7F476EFE9892": {
   "name": "Vacuum Sphere",
   "type": "ability",
   "motion": "basic"
  },
  "C407713C-8C7E-4E02-8D8D-FFE8C124645B": {
   "name": "Golden Shackles",
   "type": "ability",
   "motion": "thrust"
  },
  "4407CC75-84FB-4281-9D33-D799C7278B12": {
   "name": "Shadow Leap",
   "type": "ability",
   "motion": "charge"
  },
  "E445AEFF-BA74-4DC6-B017-865B8B64C6AF": {
   "name": "Shadow Waltz",
   "type": "ability",
   "motion": "basic"
  },
  "9F7C0FDF-CD52-4AF9-9921-6C5075C2E58B": {
   "name": "Night Arrow",
   "type": "attack_ability",
   "motion": "shot"
  },
  "8F2CDF7C-2208-4DC5-93D2-D37CDF37D45E": {
   "name": "Night Impaler",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "7CC1C5C1-1B09-4A50-B686-3C8F944BE006": {
   "name": "Malicious Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AF57C108-6751-402F-8B1C-4BBE3F51AE1A": {
   "name": "Cruel Flourish",
   "type": "ability",
   "motion": "basic"
  },
  "01ACEEC1-5FD5-400A-A69D-EE93EB706856": {
   "name": "Whirling Blades",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "5F7DC516-E290-4238-AFA8-99192ED5956D": {
   "name": "Shatterstrike",
   "type": "quick_ability",
   "motion": "smash"
  },
  "14B640E4-435C-427D-9B36-C0B158B95080": {
   "name": "Midas Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "506A1984-1FCD-8B39-AA32-9D8BFC1BEFD4": {
   "name": "Empowered Pain",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5FC4D3AA-3E04-B505-E3FB-75CE8BF6220C": {
   "name": "Royal Violence",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E1EF6627-B15A-1BF7-9CEA-7786BDC5BD5E": {
   "name": "Borrow Strike",
   "type": "ability",
   "motion": "basic"
  },
  "5F84457B-245D-EECC-1A6D-8BCA1C660F9E": {
   "name": "Rubble Throw",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "2EB72E84-EF15-67BC-330E-9EF4E61AFFFE": {
   "name": "Devastating Kick Combo",
   "type": "attack_ability",
   "motion": "kick"
  },
  "86F211C5-207C-7902-379F-393BE10C96FE": {
   "name": "High Jump Kick",
   "type": "attack_ability",
   "motion": "kick"
  },
  "2488A401-5A35-3C24-27C3-D30004F9909F": {
   "name": "Heavy Tail Sweep",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "A74DFE4B-40C1-9511-5C68-5B5B81D94435": {
   "name": "Shrapnel Throw",
   "type": "ability",
   "motion": "gesture"
  },
  "5E28F5CE-07A3-F8FF-9D34-20F16EC344C6": {
   "name": "Splicer Type Owlbear",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DF1CF2F2-3E33-9B36-B875-663D4FD0C8B4": {
   "name": "Boulder Toss",
   "type": "full_ability",
   "motion": "gesture"
  },
  "4E43ABDE-21AA-B16A-D1E8-944098789EF4": {
   "name": "Ballista Shot",
   "type": "ability",
   "motion": "shot"
  },
  "4AADDA19-4BD7-D8F4-C20A-CC81828E5E6F": {
   "name": "Rope Shot",
   "type": "ability",
   "motion": "thrust"
  },
  "1E118D94-3787-7005-94A4-32493A2E974D": {
   "name": "Catapult (8d6)",
   "type": "ability",
   "motion": "basic"
  },
  "E4A9EB5A-9B29-CBAD-B8A4-9DC078567C64": {
   "name": "Fore!",
   "type": "ability",
   "motion": "basic"
  },
  "AA302FEA-206B-02F2-A4B5-0DF1F91333CA": {
   "name": "Animal Spirit Stampede",
   "type": "ability",
   "motion": "charge"
  },
  "F983C3F0-AD2E-80BF-633F-F0BF1CB591AD": {
   "name": "Shrapnel Rain",
   "type": "ability",
   "motion": "basic"
  },
  "C923A707-5876-38CC-53F9-CF808B74B77D": {
   "name": "Wrathful Charge",
   "type": "ability",
   "motion": "charge"
  },
  "1D26A230-238E-45F1-2F53-627C2A9745F2": {
   "name": "Bloody Binds",
   "type": "ability",
   "motion": "basic"
  },
  "07A7F178-9B51-6BC0-9588-1D3B3AF53C9A": {
   "name": "Siege Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "F611959E-523A-5406-70C5-97329F243DCC": {
   "name": "Piercing Breath Weapon (15) (7d6)",
   "type": "ability",
   "motion": "thrust"
  },
  "5A901C78-DC3A-D708-96AE-F3381CE87A91": {
   "name": "Bone Shattering Strike",
   "type": "attack_ability",
   "motion": "smash"
  },
  "D3260D32-AFE3-3179-0C9C-BFA03D8FCA7E": {
   "name": "Hippo's Blood",
   "type": "ability",
   "motion": "basic"
  },
  "379C0DDC-B99C-9556-7476-761B79548FB2": {
   "name": "Glasya's Embrace",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B252FFC2-D17F-701B-6E43-1EF73AB05500": {
   "name": "Clockhand Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C6EE829A-186F-99A8-8AB5-962C4540425D": {
   "name": "Tooth Rend",
   "type": "ability",
   "motion": "basic"
  },
  "1FA53D50-6AF2-46E3-415D-D804522E6F9B": {
   "name": "Deep Impale Strike",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "32D5ABA3-0EE4-7D16-F51B-793AEECFD8A4": {
   "name": "Wild Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9C53FFAE-FFFA-5C39-2959-5D1BA0FFB3B8": {
   "name": "Heavy Axe Swing",
   "type": "attack_ability",
   "motion": "basic"
  },
  "14FA9EE5-59D7-552B-C9EA-58E042056064": {
   "name": "Treasure Explosion",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "BC65967C-6060-C325-D3D6-4B3F9BC5CB72": {
   "name": "Stinger Shot",
   "type": "ability",
   "motion": "shot"
  },
  "40017A59-BCA9-25B9-D5E3-ABE3B2B82B31": {
   "name": "Rock Throw",
   "type": "ability",
   "motion": "gesture"
  },
  "70BDE658-E95D-11C4-99DD-0E239ED67E9B": {
   "name": "Coral Fan Slash",
   "type": "ability",
   "motion": "basic"
  },
  "10F7D8EB-938D-3406-C6CD-4EBBB424831C": {
   "name": "Wildsoul Tornado",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "1D065B5C-6ADC-79D9-C1DA-2E8D3456A5F0": {
   "name": "Wildsoul Earthquake",
   "type": "quick_ability",
   "motion": "basic"
  },
  "ADCAAB70-9CC6-B14A-5068-0193F426FB51": {
   "name": "Ravager Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6EF06732-B464-B9D4-00F1-C83186DE3E1A": {
   "name": "Spirit Draining Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0AB90EDA-BA7A-71C5-F33A-6BFD7B56D9ED": {
   "name": "Cutting Thread",
   "type": "ability",
   "motion": "basic"
  },
  "9329A1A4-85CF-200E-476C-FADE36AC7249": {
   "name": "Psychic Slam",
   "type": "ability",
   "motion": "smash"
  },
  "8C8CCC3E-EAB7-1898-105F-F27B0E46E69F": {
   "name": "Totemic Quake",
   "type": "full_ability",
   "motion": "basic"
  },
  "29569F87-0376-92C7-97AA-80D723519C3D": {
   "name": "Heavy Stomp",
   "type": "ability",
   "motion": "kick"
  },
  "64F04484-34B8-7736-4E54-39F0C50E6C66": {
   "name": "Ricochet Trickshot",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3629558C-A4AF-8021-5539-81851E699007": {
   "name": "Double-Tap Discipline",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "9DD7723E-58F5-555E-DA91-9270545AD7AF": {
   "name": "Armor-Piercing Focus",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "7F9C85A8-89AC-618D-46D5-E400B0B5B081": {
   "name": "Scatter Sweep",
   "type": "quick_ability",
   "motion": "cleave"
  },
  "238249BE-B462-9C48-B34C-B235987E93DB": {
   "name": "Staggering Blast",
   "type": "attack_ability",
   "motion": "shot"
  },
  "28E3AD63-231F-1DEA-24BF-9857251E94D6": {
   "name": "Overload Pump",
   "type": "attack_ability",
   "motion": "shot"
  },
  "1EFC2142-41C7-BD91-B5FE-2D6F49999BCF": {
   "name": "Snap-Fire Reflex",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "16B373F9-2961-80AD-7DBA-3A9B5691CD14": {
   "name": "Piercing Line Shot",
   "type": "quick_ability",
   "motion": "thrust"
  },
  "A0F7E433-3228-02E7-0798-B1DBD89340E6": {
   "name": "Tracer Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "5977DE32-722A-F246-96A5-596172789ADE": {
   "name": "Flick Counter",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "7880248B-B0BE-E704-4B6D-CECBC4EDA4E3": {
   "name": "Spearwall Step",
   "type": "reaction_ability",
   "motion": "smash"
  },
  "B84094FF-7C8F-BCB8-1754-C4C28BEAE581": {
   "name": "Piercing Reprisal",
   "type": "reaction_ability",
   "motion": "thrust"
  },
  "C8169469-1B7D-D8A5-5FC0-0F123D2A7255": {
   "name": "Throw Back Hair",
   "type": "quick_ability",
   "motion": "basic"
  },
  "C7638364-6126-A364-A175-20C0321A3FE3": {
   "name": "Iron Grip",
   "type": "attack_ability",
   "motion": "shove"
  },
  "C96D38DF-636E-D2EC-7873-4744E51A572D": {
   "name": "Counter Jab",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "7DB4079B-BAE2-8CFA-DB49-96FD4BD95983": {
   "name": "Shoulder Throw",
   "type": "quick_ability",
   "motion": "shove"
  },
  "02197BF2-FAA5-A5C5-90D0-ED2433744840": {
   "name": "Palm Burst",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "B4075CBA-185B-2469-0A80-F7299E9B4032": {
   "name": "Bonebreaker Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0E84BBD1-4E87-4127-0080-DD25974B663B": {
   "name": "Heartstopper Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "04D73783-E9CE-8E3D-1A20-CED5CBEEE505": {
   "name": "Skull Rattle",
   "type": "attack_ability",
   "motion": "basic"
  },
  "1EBCD408-864B-6810-8AD7-2070562FF318": {
   "name": "Knuckle Breaker",
   "type": "attack_ability",
   "motion": "shove"
  },
  "704B0216-2E30-B652-C8C4-58106BCD1D4F": {
   "name": "Windup",
   "type": "ability",
   "motion": "whirl"
  },
  "73FF1227-A9E3-F7F5-8651-786BB2F22F21": {
   "name": "Crater Impact",
   "type": "quick_ability",
   "motion": "smash"
  },
  "08E6F2F4-E15F-DEB1-42DF-AC8D3AD2ABAF": {
   "name": "Juggernaut Rush",
   "type": "attack_ability",
   "motion": "charge"
  },
  "0D0D4A01-6BF3-AA40-AB4D-AE90AE53215D": {
   "name": "Hook Sweep",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "3DF34EEC-3F44-5B4F-18E5-20242DAB7A58": {
   "name": "Harvest Cut",
   "type": "quick_ability",
   "motion": "basic"
  },
  "C9FD783B-953A-7F6C-1D2E-8C0186B66D59": {
   "name": "Tendon Reap",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "A0F642CE-599E-72ED-4A88-20BAB3406939": {
   "name": "Reaping Wind",
   "type": "quick_ability",
   "motion": "cleave"
  },
  "0B8CDFBB-F594-22A8-090E-701553487864": {
   "name": "Crescent Execution",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "260671BB-F05A-1772-BE2B-84DBC63C664F": {
   "name": "Cracklash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6EC77F22-5A16-98C2-85B7-83313E871A94": {
   "name": "Chain Snap",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B7EE5387-85F1-B74C-51F5-C7C528ADB96B": {
   "name": "Viper’s Reign",
   "type": "attack_ability",
   "motion": "basic"
  },
  "22EB7191-1A28-01EC-32D4-940BD9DBD9BF": {
   "name": "Executioner’s Flick",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "15DD373E-DBD8-9612-2A8D-0E824A02B3C1": {
   "name": "Reflex Slice",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "A99C82D0-39EE-D867-80F5-604D6ED39DE3": {
   "name": "Piercing Lunge",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "7E9DB3CF-B457-4B73-B992-4E1FA1A62F3B": {
   "name": "Armor Tap",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F910BB45-ECB1-F107-2216-92769B091F71": {
   "name": "Bone Knocker",
   "type": "attack_ability",
   "motion": "basic"
  },
  "66858AE5-6F69-C576-626C-CADF3664F671": {
   "name": "Debilitating Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "84058284-4CB5-C69A-B2F4-FF4179E9E244": {
   "name": "Teeth Ripper",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B65ADB61-DAA3-E62E-F101-6CDF65948C1C": {
   "name": "Twin Bloom",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F25D6348-AD85-4036-84B3-CFC445FA324B": {
   "name": "Piercing Waltz",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "C6E9BA5F-02AA-797A-E61C-885C8C3857D3": {
   "name": "Serpent’s Curve",
   "type": "attack_ability",
   "motion": "basic"
  },
  "ED257761-6002-1A87-329C-F9685F284FD0": {
   "name": "Whirling Reversal",
   "type": "opportunity_attack_ability",
   "motion": "whirl"
  },
  "C0C2FCF6-1418-9A42-E043-E10B6813DD9C": {
   "name": "Glimmer Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4FC13FA7-D35E-D5F0-B3B1-A6091DF71657": {
   "name": "Pulverize",
   "type": "attack_ability",
   "motion": "smash"
  },
  "1DACF428-9F3B-54B4-A2EB-25DCDC7452E1": {
   "name": "Kneeshatter",
   "type": "attack_ability",
   "motion": "smash"
  },
  "D61A7BCB-B388-9BCE-2FF4-54791BBA654F": {
   "name": "Shockbash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "089E73A2-373E-E1CC-4796-01FF5D1AE3A7": {
   "name": "Hook Cleave",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "CC543204-D756-9CC4-80F2-769006244934": {
   "name": "Breakstep Slash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3B696BC2-CA3A-756A-F131-03732598FAE6": {
   "name": "Cyclone Cleaver",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "AD668917-ABB2-C89D-81E0-BEA5044EE76D": {
   "name": "Bone Splitter",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3DB6726F-EA29-34CE-B995-C8AE73581D4F": {
   "name": "Groundpin",
   "type": "attack_ability",
   "motion": "basic"
  },
  "10FCE834-FC33-8800-DE57-BA92E89662CF": {
   "name": "Chain Volley",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "B353E848-F607-BFBE-A1A6-B2732DBDC0CD": {
   "name": "Skybreaker",
   "type": "ability",
   "motion": "basic"
  },
  "1B8C6285-B1E3-8037-D4E1-050F7EDF7A60": {
   "name": "Gale Spin",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "4F2685E8-30F4-C00D-15E8-20DD0BD656B7": {
   "name": "Flowing River Form",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "08107EDE-4BCC-02B7-A1DD-790C0828133E": {
   "name": "Staff of Tempests",
   "type": "quick_ability",
   "motion": "basic"
  },
  "2BD3C9B6-D65C-830B-71EF-81A272E10C1E": {
   "name": "Tip Turn",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "7D5219AA-A0A2-216F-96B6-ACCDCE743127": {
   "name": "Skewer Line",
   "type": "quick_ability",
   "motion": "thrust"
  },
  "B538ED01-F9B4-1670-62B6-DFF244960AB6": {
   "name": "Staggering Point",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F7BC1FEE-1F7F-70DE-D8D0-D5AC5F3F3BD3": {
   "name": "Silver Thrust",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "2A0E3583-8CC8-CFE9-E157-85184A08C217": {
   "name": "Armor Hook",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E502DFBF-87A7-9FFE-7CFF-41B24DEB2BEA": {
   "name": "Puncture Vein",
   "type": "attack_ability",
   "motion": "basic"
  },
  "51737B84-8799-EC6E-DE9A-5F6D2C5DABDC": {
   "name": "Crater Blow",
   "type": "quick_ability",
   "motion": "smash"
  },
  "C350B1F0-84CD-BAF7-413B-13B93F91111A": {
   "name": "Skull Spike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8B6965DD-5A4F-F51F-DB24-3F8BC37E9480": {
   "name": "Crescent Maul",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CCA7F258-7DD7-DF87-BCAF-303D3D8E4F71": {
   "name": "Heavenbreaker",
   "type": "ability",
   "motion": "smash"
  },
  "BD24EBC3-8C1F-03E0-E437-57F4974188B9": {
   "name": "Low Sweep",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "A61CAC74-E61A-6262-5268-39F94D6BF77E": {
   "name": "Whipback Reversal",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "3348BB96-5C21-FF6D-7855-DD5403A69857": {
   "name": "Tangle Grip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BC15C430-CFB6-C5FB-42F2-9C2C3EEEF16A": {
   "name": "King’s Punishment",
   "type": "attack_ability",
   "motion": "smash"
  },
  "344696D7-D87E-4AF1-0A40-709A888D97FE": {
   "name": "Avalanche Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "368C7688-627D-38C8-B58E-DC9FD53EA999": {
   "name": "Enveloping Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EDBD1985-6328-05B5-BCE8-478C678E66F9": {
   "name": "Splinter Swing",
   "type": "attack_ability",
   "motion": "basic"
  },
  "203B3615-1B82-85F3-6084-F8455B46F8AF": {
   "name": "Barkbreaker",
   "type": "attack_ability",
   "motion": "basic"
  },
  "67401831-E840-3579-B004-0CBC4397E844": {
   "name": "Colossal Momentum",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B02DA64C-3E28-34D0-378D-B95288BBECC4": {
   "name": "Titan’s Descent",
   "type": "attack_ability",
   "motion": "basic"
  },
  "78B1E697-BFE9-EE06-A61C-69AC148142B6": {
   "name": "Witherstrike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "385CA81D-DA6A-F775-EEBA-0F2E52ABA9A6": {
   "name": "Measured Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9AEBF5A5-464E-2E7F-02AF-ADE44F961271": {
   "name": "Bloodhound's Step",
   "type": "attack_ability",
   "motion": "charge"
  },
  "0241D456-5645-6B75-0CC2-08666DCCCE4D": {
   "name": "Sunder Form",
   "type": "attack_ability",
   "motion": "smash"
  },
  "115A0CBC-BAA4-013E-A72A-FD5BCE553796": {
   "name": "Pinning Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "FDA73E22-8071-A406-8013-BCCBFCA4A83F": {
   "name": "Warden’s Parry",
   "type": "opportunity_attack_ability",
   "motion": "parry"
  },
  "C189F0B5-1163-93C6-0C78-EAA9A1290DED": {
   "name": "Shoulder Hew",
   "type": "attack_ability",
   "motion": "basic"
  },
  "757D28A6-ED63-F08E-538A-C6DC35956906": {
   "name": "Driving Blow",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2A4B3C0F-05BD-DD70-8B08-D3C6F5F6A9C5": {
   "name": "Breaker’s Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6C061DFB-E581-E36E-28A2-13BFC1138306": {
   "name": "Hook Step",
   "type": "attack_ability",
   "motion": "kick"
  },
  "3293B4DB-D482-8DE3-1C57-F022B55A1888": {
   "name": "Pole Control",
   "type": "attack_ability",
   "motion": "basic"
  },
  "90301C22-2A20-2BA1-1223-B0CC3E21032F": {
   "name": "Breaker’s Circle",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "64AD3DE5-27BD-532E-3145-D0D2344BCEB5": {
   "name": "Axe Return",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "82131816-2AD0-5229-84CD-CEB7D453638B": {
   "name": "Line Splitter",
   "type": "quick_ability",
   "motion": "basic"
  },
  "7BC63310-6F1C-5699-B41A-A7B87FB57C84": {
   "name": "Phalanx Push",
   "type": "attack_ability",
   "motion": "shove"
  },
  "E0ABF7EB-F35C-609B-4A50-BAE8877A4F36": {
   "name": "Staggerline Hold",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "3A18A1C0-7427-FD42-2A3A-F69CDE361EC8": {
   "name": "Step-Through Impale",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "5C1369BC-5EFC-7EE9-B3AD-56315B249DB1": {
   "name": "Rupture Swing",
   "type": "attack_ability",
   "motion": "smash"
  },
  "5F63F7C8-6B39-102B-8107-35CC1EDF1398": {
   "name": "Measured Thrust",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "EDCB2978-27AF-90FE-42AE-25079E036977": {
   "name": "Step-Through Lunge",
   "type": "quick_ability",
   "motion": "thrust"
  },
  "AB81AC3F-D6C6-0724-8839-2156BFB5A56A": {
   "name": "Armor Seam",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B877E70C-F464-64E5-6ED4-A88232C31703": {
   "name": "Cross-Spin",
   "type": "opportunity_attack_ability",
   "motion": "whirl"
  },
  "42298EB8-56EF-BB0D-CA51-C54CAD138028": {
   "name": "Hooked Pivot",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5B18DDC5-DB33-21B4-9B86-7A8C9209AF4A": {
   "name": "Breaking Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "44F1B95E-AE22-95D9-5A29-6BC6ECCF0EFC": {
   "name": "Rising Cut",
   "type": "attack_ability",
   "motion": "basic"
  },
  "92030BA0-8E25-BE67-535D-AD84511A2A2B": {
   "name": "Weighted Pull",
   "type": "attack_ability",
   "motion": "basic"
  },
  "99EC7880-B2ED-D07A-5FF6-EBC49557081E": {
   "name": "Snap Throw",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "F66E1266-B2D9-DFB0-2CBA-D6FA427ADEB5": {
   "name": "Low Throw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0CCA10E2-A998-5A33-08E3-00438B76D6DC": {
   "name": "Knuckle Release",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F3F1B61D-2C04-BBCF-BEC9-1D2FAF56123A": {
   "name": "Marking Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "78A6C067-8C02-2546-839A-1C4521F246C7": {
   "name": "Underhand Cast",
   "type": "attack_ability",
   "motion": "shot"
  },
  "FA4D1CBD-C1EA-2A66-E0A1-3AAA6389B8BC": {
   "name": "Stagger Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "8A99A0B1-C4F0-3A87-0F21-AA5A6094DB9D": {
   "name": "Skip Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "4EAC239A-9392-6B59-B00F-62F7CC960CE9": {
   "name": "Double Nock",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8B20FC50-2D81-9F52-246F-6EA949270D0D": {
   "name": "Quick Nock",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "DE6EC01E-8BFB-A479-53B7-90B51B1AF0A6": {
   "name": "Slug Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "5EB52A0B-F09E-F09C-38CA-04517462F6DC": {
   "name": "Lacerating Shot",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "0D66C7A1-321C-89B6-2194-A212C5870C1A": {
   "name": "Follow-Through",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DE611C90-9DB1-E801-C945-4B1FD6478F11": {
   "name": "Twin Bolts",
   "type": "attack_ability",
   "motion": "shot"
  },
  "3FB4B7CD-BD1E-7187-860B-ACFB93EC3C84": {
   "name": "Quick Pinner",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "5DA8EAF3-A814-CD7E-B9FF-2B2AFCE0A200": {
   "name": "Reflex Bolt",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "D2681762-3FD0-5985-6BC8-DC10BCFC9D3B": {
   "name": "Full Draw",
   "type": "ability",
   "motion": "shot"
  },
  "0FAB7C26-F0C4-A00D-8FC0-B9EAD9C916E1": {
   "name": "Volley Pair",
   "type": "attack_ability",
   "motion": "shot"
  },
  "D5B5B984-3A69-2FFF-39A3-02E944D38E66": {
   "name": "Low Arc Bolt",
   "type": "attack_ability",
   "motion": "shot"
  },
  "6749F471-D1A9-EA2D-FED0-E03947DB68F6": {
   "name": "Braced Burst",
   "type": "attack_ability",
   "motion": "shot"
  },
  "E818DEEF-6F47-AB03-007A-752D8196BF4A": {
   "name": "Snap Shot",
   "type": "opportunity_attack_ability",
   "motion": "shove"
  },
  "F5CD12E2-2717-8A82-70C6-15AB59335A48": {
   "name": "Iron Bolt",
   "type": "attack_ability",
   "motion": "shot"
  },
  "58FC1E60-C7E5-C2A3-FE69-09F44C37F5B0": {
   "name": "Full Line",
   "type": "quick_ability",
   "motion": "thrust"
  },
  "411AE650-1D36-2265-DA1A-4B954575921B": {
   "name": "Armor Breaker",
   "type": "attack_ability",
   "motion": "basic"
  },
  "77146121-E070-197F-247C-D46E7606B650": {
   "name": "Spinning Grind",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "1595E61F-7785-5382-C0AE-92F79E249A8C": {
   "name": "Rain-Splitter Counter",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "F56B81ED-97F6-558C-C8DC-5BFAFD33B1F5": {
   "name": "Fanblade Flurry",
   "type": "attack_ability",
   "motion": "flurry"
  },
  "CA21EBE0-821D-15C5-3528-5C8C7447A401": {
   "name": "Cutting Draft",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "6E52D44E-BBE6-4A20-914D-D6612FC54520": {
   "name": "Petal Scatter",
   "type": "quick_ability",
   "motion": "basic"
  },
  "1509DE0C-B1D3-2664-6C16-820BCA7B61AE": {
   "name": "Twinfold Volley",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "DF752452-9548-4685-9CA0-151706D25CC3": {
   "name": "Hand Piercing",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "2C735424-188C-80B6-4312-F8F2371EAB78": {
   "name": "Piercing Cast",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "D0AF1CF1-D841-92A7-A43D-4DA10A3489AE": {
   "name": "Snaring Twist",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DC607BB8-7580-35A6-CFEC-8D1AF87CC238": {
   "name": "Ghost Recall",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "0851E89B-D61E-3142-AB75-8F4D9C8C7A28": {
   "name": "Driving Knuckle",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0632FF1C-3741-72CB-D264-26A7ECCF2FDD": {
   "name": "Guard-Break",
   "type": "attack_ability",
   "motion": "parry"
  },
  "AB9822A9-471E-8F1D-E8E6-AAA2A9226965": {
   "name": "Rattle Combination",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0C943435-030A-A6AA-644B-18269E7A83E3": {
   "name": "Counter-Impact",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "A6A07ABA-0C42-0702-B171-DDF71E069920": {
   "name": "Falling Star Swing",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A4312B3E-1F45-2598-8ED6-E054DDC73DD4": {
   "name": "Orbiting Menace",
   "type": "ability",
   "motion": "smash"
  },
  "6E247979-FE97-EC33-560C-E6C99CAEFB8A": {
   "name": "Chain-Drag Smash",
   "type": "attack_ability",
   "motion": "smash"
  },
  "6D66D6B4-82BD-702E-E3B4-7ED610DEF90D": {
   "name": "Cataclysmic Wind-Up",
   "type": "full_ability",
   "motion": "smash"
  },
  "11296725-436D-8E33-22E3-8585E1787EAA": {
   "name": "Pulverizing Rebound",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "1E92C276-A712-EE7E-1326-66E6FF978FE5": {
   "name": "Meteor Path",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "D7C36243-ED14-FFDA-D527-A62252FD5CC7": {
   "name": "Rend Across",
   "type": "attack_ability",
   "motion": "basic"
  },
  "88FDF563-959F-A3F4-897F-3A461C294403": {
   "name": "Hook and Hurl",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7A19EF49-39FA-C691-67EE-5728016C8401": {
   "name": "Impale and Leverage",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "FC975B53-CE0D-6C94-FCE1-535C9988C3A8": {
   "name": "Shredding Counter",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "EABD3F6E-B25B-28BD-B0AE-6F44407D6DB8": {
   "name": "Executioner's Arc",
   "type": "attack_ability",
   "motion": "finisher"
  },
  "71611DC1-A456-57F1-85FD-D97FC6E9AE6A": {
   "name": "Linebreaker Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "0EDD33B5-BAAF-C5EE-589C-7135D678DFC5": {
   "name": "Anchor the Beast",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "2B48D3A0-A418-2108-B68A-A2179DC8024C": {
   "name": "Cavalry Reaper",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "93E777A1-5690-D8DA-8DF7-5E838AEB90FC": {
   "name": "Siege Ram",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6B3ED577-A1E3-1AA2-EFD2-198FD461A315": {
   "name": "Piercing Toss",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "417BEF20-F461-B649-53AA-B723DABFDF3E": {
   "name": "Line-Cleaver Shot",
   "type": "ability",
   "motion": "cleave"
  },
  "039B0516-CB26-8317-A284-42893C7518C6": {
   "name": "Shield-Killer Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "2CD1B01B-789B-1C52-5C12-AE07701D5B78": {
   "name": "Giant's Draw",
   "type": "full_ability",
   "motion": "shot"
  },
  "98FEFCD9-4636-92F9-46BA-2E914F3091AB": {
   "name": "Formation Parting",
   "type": "ability",
   "motion": "shot"
  },
  "62EFAC05-9185-7273-732E-BCB58F69A0E1": {
   "name": "Last Volley",
   "type": "ability",
   "motion": "shot"
  },
  "813FE2B6-5488-67AE-900B-3ACD1190F2E3": {
   "name": "Impale (d10)",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "6CA9555A-FE9B-F1EB-5877-36F8040112C6": {
   "name": "Fungal Fling",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "FDA08D6B-D82D-A87D-A23E-75E6B8976D0D": {
   "name": "Staff Slam Combo",
   "type": "ability",
   "motion": "smash"
  },
  "A33E28D9-AF08-9585-6790-4F5AD7DF8D4C": {
   "name": "Object Fling",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "441E41CD-93AC-3CF3-0D44-B54719A0F0A2": {
   "name": "Knockdown Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0BB5D742-366D-1DCC-6C93-1F5A18425BE1": {
   "name": "Bone Saw Attack",
   "type": "quick_ability",
   "motion": "basic"
  },
  "8D42664F-406A-25F1-62E3-C992845141DD": {
   "name": "Hindering Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5B6F0CFA-4E00-8B94-1C8C-E79A79082C2B": {
   "name": "Pulling Attack (15ft)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "06C3EBC3-9F08-5DCC-A4AB-1DCC3C9F3B33": {
   "name": "Thorn Spray",
   "type": "ability",
   "motion": "basic"
  },
  "3824790C-D0D8-355C-5417-4F32A9AA959F": {
   "name": "Consuming Bite (Devourer Only)",
   "type": "attack_ability",
   "motion": "shove"
  },
  "8DC0EA80-A54C-DAEF-D488-CF69B40C2255": {
   "name": "Chew",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7E3CF5E2-14EE-1FF2-8839-BAF13E926643": {
   "name": "Tentacle Lash",
   "type": "ability",
   "motion": "cleave"
  },
  "E7D46489-E5EE-3518-D21B-A805710F4EAE": {
   "name": "Mountain Splitting Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A4A5B9E1-E6D1-CE07-F874-067C776F5BA8": {
   "name": "Twin Horizon Arc",
   "type": "ability",
   "motion": "cleave"
  },
  "20C5D7FB-1BC5-EC35-FC13-6E1B507D9678": {
   "name": "Tri-Strike Tempest",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3C6A42AD-FBCE-C1E9-7CFD-1650689DF71C": {
   "name": "Heaven's Fall",
   "type": "full_ability",
   "motion": "smash"
  },
  "6F79B2C1-007C-D619-5685-FA734688F96A": {
   "name": "Hit With Butt of Gun",
   "type": "quick_ability",
   "motion": "basic"
  },
  "1B9F4BC0-534C-62C9-D2A2-68E76938B7F1": {
   "name": "Sleep Claws",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A96CBB45-A090-415C-3359-4FC611885EEF": {
   "name": "Choke Hold",
   "type": "attack_ability",
   "motion": "shove"
  },
  "491DBC3B-2B72-39CE-A1B5-3A9CB7125699": {
   "name": "Garrote Counter",
   "type": "opportunity_attack_ability",
   "motion": "shove"
  },
  "FA0F3E58-269D-E972-F2C4-A58BC22DF9E2": {
   "name": "Bloodline Wire",
   "type": "attack_ability",
   "motion": "shove"
  },
  "4B369F81-76F9-03C4-82C1-CBE81329B18F": {
   "name": "Suffocating Hold",
   "type": "attack_ability",
   "motion": "shove"
  },
  "ACD396E8-136D-E03C-9E21-74F8084B4948": {
   "name": "Bonecracker Round",
   "type": "attack_ability",
   "motion": "smash"
  },
  "56855BAD-296B-FF5C-E3E7-326EEE449293": {
   "name": "Execution Line",
   "type": "full_ability",
   "motion": "shot"
  },
  "82907AE2-0467-D3CD-C1BC-3FEF0221E22A": {
   "name": "Ruiner Volley",
   "type": "attack_ability",
   "motion": "shot"
  },
  "D44BA6CC-3E86-87AD-EEAD-E6E5C14B4CE5": {
   "name": "Blunt Force Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "92DC8FD2-1A88-02D1-A591-9F969BC7B288": {
   "name": "Big Swing",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D1EA8C90-300C-9EC4-AD20-2D4D53D22A6B": {
   "name": "Armor Shredding Blow",
   "type": "attack_ability",
   "motion": "smash"
  },
  "9289ED59-50EB-9A6C-D120-A5129DEDA84E": {
   "name": "Shatter Quake",
   "type": "ability",
   "motion": "smash"
  },
  "0CC34ADE-82A7-8AC1-63A4-DAAAA3585EAC": {
   "name": "Shoot Multi-Strike Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "4CD938AD-1B82-4992-8B2A-A35B15F6E0A9": {
   "name": "Shoot Aberration Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "61622701-3F07-851D-5444-E9EB4AF8A410": {
   "name": "Shoot Beast Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "68566F24-5E25-C40C-26E2-245FED7F53B1": {
   "name": "Shoot Construct Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "5FB56348-742F-52FB-CB90-5796E97E331F": {
   "name": "Shoot Dragon Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "535E8545-8577-14DE-7B34-66A8FC2774FF": {
   "name": "Shoot Elemental Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "8718B077-A953-D767-52A9-B464E6C4AEB8": {
   "name": "Shoot Fiend Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "8E2F84E1-F4AF-6830-E6A5-B5A955692C67": {
   "name": "Shoot Humanoid Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "F8E3B6A1-8A26-AA2C-82AC-CFBDDDED4BFD": {
   "name": "Shoot Monstrosity Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "A952E725-1398-ECF4-2973-6A214C675BD5": {
   "name": "Shoot Celestial Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "C51799F4-CD64-F1DB-FB21-3AE208495078": {
   "name": "Shoot Undead Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "6AC7F88C-38F6-B27F-5C46-A11AC8F7D375": {
   "name": "Shoot Fey Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "9E714092-9545-D96B-BF99-118870B5C7B0": {
   "name": "Shoot Giant Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "B1B87727-5571-34FC-C45F-90B2D606B792": {
   "name": "Shoot Ooze Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "B6EAD74A-1452-0E83-1F5D-E6FD7FC18CAC": {
   "name": "Shoot Plant Slaying Arrow",
   "type": "quick_ability",
   "motion": "shot"
  },
  "B2920A46-5D4E-E3AA-2B35-D04D6EAE7C5E": {
   "name": "Shoot Aberration Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "D0919E3E-2245-9247-F17B-1F29FC7B0D60": {
   "name": "Shoot Bullet of Beast Slaying",
   "type": "quick_ability",
   "motion": "shot"
  },
  "54AC9E5E-D447-FF7F-EB17-B39DA86B3FAC": {
   "name": "Shoot Celestial Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "643F0F6A-D2FB-79FE-E859-C544794F7A53": {
   "name": "Shoot Construct Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "3FA44D2A-DE5B-BA72-2FAB-023E75FA2D43": {
   "name": "Shoot Dragon Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "7506AE12-C0EB-5BE3-1D6B-48038D42DF9A": {
   "name": "Shoot Elemental Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "42C92A45-F14E-81B0-0022-1815044791EB": {
   "name": "Shoot Fey Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "7F465323-6EF8-EA42-8B7F-DEF337CBCE12": {
   "name": "Shoot Fiend Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "9AF24B27-CC71-5175-F939-606B1C731B91": {
   "name": "Shoot Giant Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "08397694-836B-EB0C-0AD3-0FF3256318CF": {
   "name": "Shoot Humanoid Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "10AB30E5-4DCF-2535-B84A-DCD667EC7267": {
   "name": "Shoot Monstrosity Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "91D99FFC-586E-CAB1-4AE6-D1945C435E2F": {
   "name": "Shoot Ooze Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "FF885F06-5862-CFFA-AA0D-BF3796B75892": {
   "name": "Shoot Plant Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "43F37B79-8355-41BE-CC75-CFCEDDDE3CBA": {
   "name": "Shoot Undead Slaying Bullet",
   "type": "quick_ability",
   "motion": "shot"
  },
  "DA39470D-610E-0244-1EF9-8559BEBD6E22": {
   "name": "Shoot Aberration Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "71B832B7-EECF-195F-06A5-08C27B7BE33D": {
   "name": "Shoot Beast Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "FAE15117-317A-5852-EE78-2276041705BE": {
   "name": "Shoot Celestial Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "DE690954-25A2-B7D0-130F-AD3B0B1E3B4A": {
   "name": "Shoot Construct Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "39D3E9F8-F82B-62AD-7E2E-96ED9265EB81": {
   "name": "Shoot Dragon Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "9F1B9F6C-691E-F916-4380-E2A2E978C157": {
   "name": "Shoot Elemental Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "654F3F4E-F6BF-5EFF-6A0C-7943DE1922A9": {
   "name": "Shoot Fey Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "7221A8B9-4070-32CD-7978-CD128CE6E7FD": {
   "name": "Shoot Fiend Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "C1F6E71C-914B-141D-056A-48A8CA3DA891": {
   "name": "Shoot Giant Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "D898F5A7-8C0D-4BD9-B21F-740DB5526352": {
   "name": "Shoot Humanoid Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "B71FF117-987C-55C5-F48A-75D400B408D7": {
   "name": "Shoot Monstrosity Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "C9A28C1E-F6C7-F16F-894A-0943B1C3DEB3": {
   "name": "Shoot Multi-Strike Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "9BD0C5AA-A0C2-9D7F-E335-ECB7FAEFD045": {
   "name": "Shoot Ooze Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "9E5DC5E2-3837-AB53-F7B7-6619C027540C": {
   "name": "Shoot Plant Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "50C4273B-9436-E932-1025-A24C46F221A2": {
   "name": "Shoot Undead Slaying Bolt",
   "type": "quick_ability",
   "motion": "shot"
  },
  "41212205-31B1-8471-AEE8-A1819B5FCCDA": {
   "name": "Liquid Metal Lasher",
   "type": "full_ability",
   "motion": "basic"
  },
  "CAD73587-692C-9C95-914E-AE9E7978E9B4": {
   "name": "Shoot Arrow of Crippling",
   "type": "quick_ability",
   "motion": "shot"
  },
  "FB33C6D6-9AF6-61AA-29C4-833512A60158": {
   "name": "Shoot Arrow of Tracking",
   "type": "quick_ability",
   "motion": "shot"
  },
  "8B314349-EEDA-F297-5B55-9D1E3AB38CC7": {
   "name": "Shoot Arrow of Bloodletting",
   "type": "quick_ability",
   "motion": "shot"
  },
  "245337F7-0E4C-DFF8-9E25-4E138B510086": {
   "name": "Shoot Arrow of Colossus Slaying",
   "type": "quick_ability",
   "motion": "shot"
  },
  "94DA7AEE-B848-6206-81AD-47D6A41757EF": {
   "name": "Shoot Bolt of Iron Rain",
   "type": "quick_ability",
   "motion": "shot"
  },
  "6854DB9D-E80D-5374-08AB-094D4DCDA569": {
   "name": "Shoot Bolt of Seeking",
   "type": "quick_ability",
   "motion": "shot"
  },
  "DF48FE25-065D-4DFE-93DD-8FDEC8A0703D": {
   "name": "Shoot Bolt of Stunning",
   "type": "quick_ability",
   "motion": "shot"
  },
  "381DDFA2-3510-12D9-9C3C-83C9230E62FC": {
   "name": "Great Impact",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E85AB672-504D-5A58-6C5F-A7842083F521": {
   "name": "Pointy End Bleeding Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9AD8EEE7-835E-6D9C-EB4D-5E63D8A37165": {
   "name": "Rain of 300 Spears",
   "type": "full_ability",
   "motion": "basic"
  },
  "46DFD891-2C04-DDC7-7C85-2E87FD4BB18B": {
   "name": "Judgment of the Sky",
   "type": "ability",
   "motion": "basic"
  },
  "284D3999-14EA-D3E9-01A8-262AD0873EE0": {
   "name": "Chilling Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E2A87D5D-98A0-5FB2-B6D7-E778E96B83CB": {
   "name": "Stone Shot",
   "type": "quick_ability",
   "motion": "basic"
  },
  "BD6A3181-7604-F753-A801-232633DE2F00": {
   "name": "Hooking Edge",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0BFF3F27-1AD9-72E0-E55B-6A63E469DCD6": {
   "name": "Exposing Fling",
   "type": "attack_ability",
   "motion": "parry"
  },
  "17F5D4A0-7F18-0709-ADCF-10A0CD1B9311": {
   "name": "Bleeding Swipe",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B5F1C457-17DE-4078-8B10-828B95A61FBC": {
   "name": "Ricochet Throw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EFEB2147-F161-5A64-0526-B0B9CB9AED5A": {
   "name": "Returning Guillotine",
   "type": "ability",
   "motion": "basic"
  },
  "C20C8E3D-97A9-E0E7-26C5-519B75D9EECD": {
   "name": "Diseased Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DC40B909-07E5-2E8C-B04B-0F3376CC654C": {
   "name": "Reel Them In!",
   "type": "attack_ability",
   "motion": "shot"
  },
  "BA042DB0-1C68-CFC8-CEDF-5FF9B9A3C83A": {
   "name": "Shield Splitter",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7E47210D-8FCE-994A-DDB4-1B364EDE19F3": {
   "name": "Reaping Curve",
   "type": "ability",
   "motion": "cleave"
  },
  "D9858E90-8BEA-308C-18B0-D6936B5DCA18": {
   "name": "Rib-Ringer Bash",
   "type": "attack_ability",
   "motion": "shield_bash"
  },
  "495808B8-A80A-99F8-48D0-A2D25459671A": {
   "name": "Spinning Death",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "F7A8ED0B-7317-6990-B767-D25AD7D8F4D0": {
   "name": "Teleporting Attack (30ft)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3C5F32BD-F7B5-760F-7E1C-5E28D5C1A1B5": {
   "name": "Giant Hunter",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C2848B0E-3FE6-318E-0506-9F0C20E114D6": {
   "name": "Defense is Meaningless",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BBDD2853-1477-A5DA-2218-CECA8B4A778F": {
   "name": "Bloody Gash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "FDE1D8D1-3498-DB17-7532-332246168665": {
   "name": "Aim for the Eyes",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B6F53C55-32B2-E461-BAEF-5617417EA5A6": {
   "name": "Ashen Step",
   "type": "quick_ability",
   "motion": "charge"
  },
  "A29716F1-F085-479A-7C23-360676B791F5": {
   "name": "Wrap and Fling",
   "type": "quick_ability",
   "motion": "shove"
  },
  "1EDF7E2B-74CB-4427-4140-BD189C1728B2": {
   "name": "Rock Launch",
   "type": "ability",
   "motion": "gesture"
  },
  "8168ED1F-12A0-84FD-6B1B-B2754F1B0D17": {
   "name": "Acid Etch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "34844FA3-8DCD-425C-6A9E-213DBF50AFB6": {
   "name": "Poison Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C4CE5F9D-1F7E-D685-D8CC-B0A645D040ED": {
   "name": "Exo Dart",
   "type": "ability",
   "motion": "whirl"
  },
  "9EDB4ACA-712B-9533-89BB-3331B46DB726": {
   "name": "Enhanced Arms",
   "type": "attack_ability",
   "motion": "basic"
  },
  "27EB89A3-9177-1479-5834-CF7ABE24F122": {
   "name": "Sacred Mace",
   "type": "attack_ability",
   "motion": "smash"
  },
  "83438A5C-D38C-C92A-C499-BFC9FA6F8EAB": {
   "name": "Grappling Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E002C416-6073-729E-B675-3D384F3EECF4": {
   "name": "Crushing Coils",
   "type": "quick_ability",
   "motion": "smash"
  },
  "12063CD2-3EC4-01F1-DE94-F1592C72FD6D": {
   "name": "Maiming Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4471016A-BA73-52EB-A283-EDB01656D0A6": {
   "name": "Chokeslam Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C702ED11-A784-BF8B-F32D-6173C64E26E1": {
   "name": "Bleeding Strike, Adept",
   "type": "attack_ability",
   "motion": "basic"
  },
  "30FF1C26-62FE-C54B-9046-3165BBCBA150": {
   "name": "Poisoned Barb",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C68BFA98-4B24-F904-0883-0ED9447661AD": {
   "name": "Transmute Living Flesh",
   "type": "ability",
   "motion": "basic"
  },
  "0A7539C8-0B3D-3EF2-8648-E34E035DEAF4": {
   "name": "Iron Acorn Volley",
   "type": "ability",
   "motion": "shot"
  },
  "F9F94365-534B-48D1-899E-26C5D3A83D64": {
   "name": "Iron Growth",
   "type": "ability",
   "motion": "basic"
  },
  "3EFE943F-49EA-2881-887E-DC8D51872FE5": {
   "name": "Precise Dismemberment",
   "type": "ability",
   "motion": "basic"
  },
  "CEF9EFE5-9F03-5808-605D-BA86FFB73118": {
   "name": "Shredding Charge",
   "type": "ability",
   "motion": "charge"
  },
  "67AF4D54-89FB-357B-0BE8-92FC89A2CA8C": {
   "name": "Iron Shards",
   "type": "ability",
   "motion": "gesture"
  },
  "1C38F3DE-737E-5170-6ABE-55F0F1C16FC6": {
   "name": "Barnacle Latch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C3681E4F-FF26-F7B7-1760-414ED40E4501": {
   "name": "Barnacle Whip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "083EB4B1-8030-493D-AC0F-46412C91CE8A": {
   "name": "Mechanical Cannon",
   "type": "ability",
   "motion": "shot"
  },
  "FF5F78E8-FC75-465B-BBB5-CC3D74874B53": {
   "name": "Shred",
   "type": "ability",
   "motion": "basic"
  },
  "F550B57C-4903-4308-9AAB-174659C84EE0": {
   "name": "Crushing Kick",
   "type": "attack_ability",
   "motion": "kick"
  },
  "AB78F233-324C-C2FE-E064-179B5F1678A3": {
   "name": "Shard Sling",
   "type": "ability",
   "motion": "gesture"
  },
  "89D6CF5B-5712-2A4D-238C-33AF39761C9C": {
   "name": "Flagon Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "94F6C6D5-5D6F-1219-05DF-6709437FB4D5": {
   "name": "Chain Lash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DFDB79EC-9EA8-29DC-9D98-E6B864C63B0A": {
   "name": "Chain Slam",
   "type": "ability",
   "motion": "smash"
  },
  "CF001DA9-2100-4F00-9B21-C40C01E50002": {
   "name": "Ribbon",
   "type": "attack_ability",
   "motion": "shove"
  },
  "7E721DA9-2200-4F00-9B22-C22C22E50002": {
   "name": "Cauldron Slam",
   "type": "attack_ability",
   "motion": "smash"
  },
  "7E721DA9-2200-4F00-9B22-C22C22E50005": {
   "name": "Crushing Leap",
   "type": "ability",
   "motion": "smash"
  },
  "FFC3E269-3F57-8919-C202-5F7BE63D5F5C": {
   "name": "Brutal Cleaver",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "E74E81B6-CE06-8DDD-7309-03E9DBDCA48B": {
   "name": "Feinting Attack",
   "type": "attack_ability",
   "motion": "parry"
  },
  "49A4F036-8ED7-2E7B-7298-B978498C3A9A": {
   "name": "Disrupting Shot",
   "type": "attack_ability",
   "motion": "shot"
  },
  "BFF80480-B92F-3218-E8CA-14941FF78ACC": {
   "name": "Nature's Wrath (4d6)",
   "type": "ability",
   "motion": "smash"
  },
  "ABC6F6D0-A9D0-9289-8994-F0E87CEF770F": {
   "name": "Nature's Wrath (4d8)",
   "type": "ability",
   "motion": "smash"
  },
  "E0EB3CE0-E8B1-1852-F0E2-0C1BD2A04DD6": {
   "name": "Grapple Fling",
   "type": "ability",
   "motion": "shove"
  },
  "516FD0FF-F64E-CD73-99A6-07700D28A9D9": {
   "name": "Retaliatory Fling",
   "type": "reaction_ability",
   "motion": "shove"
  },
  "F347105C-2455-4E84-353D-E5BBD693AECC": {
   "name": "Opening Strike",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "AB71BF5B-DA13-3625-8E7E-4DCB6236C091": {
   "name": "Stunning Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3261BE5F-D965-953B-26C7-5A56A0EB461C": {
   "name": "Flurry of Darts",
   "type": "ability",
   "motion": "flurry"
  },
  "D0CF5C9B-D3CB-401D-E90B-4AE7EFA72A80": {
   "name": "Headsman's Axe",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "548C39CD-D280-4577-C990-5C014A9187E4": {
   "name": "Soul Blade",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DE9F88BE-8B60-AEE8-C9DE-4E779C3FE4D6": {
   "name": "Searing Claw",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "EE8E5658-519C-79EA-3B92-C28811CD4E12": {
   "name": "Blazing Boulder",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B77965DF-46B8-BAE1-E468-119F50FC2583": {
   "name": "Cataclysmic Rupture",
   "type": "ability",
   "motion": "basic"
  },
  "3C4C5D08-8D13-7F98-6E6C-A5697D4EF3C7": {
   "name": "Grasping Claws",
   "type": "attack_ability",
   "motion": "whirl"
  },
  "3405CFED-59F4-E9F1-7270-339624A673E5": {
   "name": "Hurled Boulder",
   "type": "ability",
   "motion": "gesture"
  },
  "103E1241-7252-DBFE-DDF9-22A162CDC852": {
   "name": "Arm Sweep",
   "type": "ability",
   "motion": "cleave"
  },
  "79206C9F-34E7-0081-3D3A-463C2FA3F9A2": {
   "name": "Enervating Touch",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A51468F0-5FD5-7A1E-E8F4-E0318D889719": {
   "name": "Snuff Warmth",
   "type": "attack_ability",
   "motion": "basic"
  },
  "BCBA999F-A001-1A3E-634C-2225F9C3A899": {
   "name": "Swamp Surge",
   "type": "ability",
   "motion": "basic"
  },
  "8D7DBE79-5BA3-2542-353F-A147CB654BBD": {
   "name": "Constricting Grip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B93F62C7-BD8E-0F68-A11A-ABBA1105E706": {
   "name": "Trample",
   "type": "quick_ability",
   "motion": "smash"
  },
  "D94E486E-FDEF-6E36-CD36-D230959DD433": {
   "name": "Powder Shot (300) (4d6)",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "855C3C9B-1E6D-C459-3645-C31934CB46C8": {
   "name": "Crush",
   "type": "quick_ability",
   "motion": "smash"
  },
  "4C33D1B6-AC2F-DEEF-A657-00BB9360844E": {
   "name": "Petrifying Grip",
   "type": "attack_ability",
   "motion": "basic"
  },
  "D66D58DE-89DD-429B-BC22-F0867E48F74D": {
   "name": "Vice",
   "type": "quick_ability",
   "motion": "basic"
  },
  "EF1686D4-924B-4A6B-90A9-8AFBA1D9AE93": {
   "name": "Slicing Charge",
   "type": "ability",
   "motion": "charge"
  },
  "D33D3013-5815-8A74-65B6-5459269B50D1": {
   "name": "Tighten Chain",
   "type": "quick_ability",
   "motion": "shove"
  },
  "47AA0792-357A-8084-C30E-46C328D81FB4": {
   "name": "Ensnaring Spray",
   "type": "ability",
   "motion": "basic"
  },
  "B86738F6-5AB1-210A-5F3B-BCBFB15309BA": {
   "name": "Mind-Sapping Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EB3A6486-948F-57A3-E2DE-9CA8D6A10A6C": {
   "name": "Searing Flash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "E35C38AB-946A-AD16-D244-654191D18366": {
   "name": "Mana Siphon Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AF8F2B79-3C9F-9924-4A5F-7E064989080B": {
   "name": "Blinding Rider",
   "type": "attack_ability",
   "motion": "basic"
  },
  "0E1D9392-B5E7-E7C4-8069-623B8834C5CC": {
   "name": "Retaliatory Tail Strike",
   "type": "reaction_ability",
   "motion": "cleave"
  },
  "17DBB7EE-5F59-718F-2CDB-BB3EE9DC1420": {
   "name": "Teleporting Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "25F8A860-BB12-9737-0837-C8F62EA668D9": {
   "name": "Tail Knockback Attack (10)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "82786050-BC9F-A0A7-C882-9A8394575384": {
   "name": "Dive Bomb Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A0B1E008-0800-4F08-9B08-A00000000002": {
   "name": "Razor War Pick",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A0B1E008-0800-4F08-9B08-A00000000003": {
   "name": "Razor Javelin",
   "type": "ability",
   "motion": "gesture"
  },
  "4E63D80F-9A90-E6D0-6458-24FD72E6F70B": {
   "name": "Blazing Charge",
   "type": "attack_ability",
   "motion": "charge"
  },
  "E7E20257-185C-3BD8-1D83-33040E8FE697": {
   "name": "Sweeping Riposte",
   "type": "opportunity_attack_ability",
   "motion": "cleave"
  },
  "718C082C-46B3-82BF-5308-B15613CC289A": {
   "name": "Rend Retaliation (1d8)",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "686B3CED-86A2-545F-BB29-558A1322A264": {
   "name": "Rend Retaliation (2d8)",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "34554242-CBDF-4F1D-A0A9-0CE60F50F1D5": {
   "name": "Pie Toss",
   "type": "ability",
   "motion": "gesture"
  },
  "02EFDE4A-3FF6-3975-627F-2F1E4071D646": {
   "name": "Molten Sand Breath (15) (4d8)",
   "type": "ability",
   "motion": "smash"
  },
  "3868917E-87DB-79ED-7FD7-41A338342BF8": {
   "name": "Molten Sand Breath (30) (12d8)",
   "type": "ability",
   "motion": "smash"
  },
  "43D5F6F2-E6DD-B67D-9091-1EDF5131BF74": {
   "name": "Molten Sand Breath (60) (14d8)",
   "type": "ability",
   "motion": "smash"
  },
  "96EA2994-1350-6B1D-8FBA-09CE9F511BFC": {
   "name": "Molten Sand Breath (90) (16d8)",
   "type": "ability",
   "motion": "smash"
  },
  "FB862E52-FFF7-4E5E-565F-15BDF2AB97A9": {
   "name": "Vril War Pick",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6E1C8907-AB27-8A0A-D12E-B133A5437ECA": {
   "name": "Vril Javelin",
   "type": "ability",
   "motion": "gesture"
  },
  "D72B2A3E-70F3-B93F-2016-2D7FB9C7B807": {
   "name": "Vril Quarterstaff",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9E91E90D-E4A9-20DD-2D56-0ED62637F0FF": {
   "name": "Hurl (12d12)",
   "type": "ability",
   "motion": "gesture"
  },
  "7F8EC110-6034-1E23-5CDA-CDE31CA6AEC3": {
   "name": "Hurl (8d12)",
   "type": "ability",
   "motion": "gesture"
  },
  "8DF5D6A9-C48D-3A82-D88E-798274487CC2": {
   "name": "Hurl (6d12)",
   "type": "ability",
   "motion": "gesture"
  },
  "054BFFD7-5CE5-B38A-19A0-507FAA9FBC8F": {
   "name": "Hurl (3d12)",
   "type": "ability",
   "motion": "gesture"
  },
  "81199222-057C-1FF7-C228-DCAAD765493C": {
   "name": "Toppling Sweep (30) (4d6)",
   "type": "ability",
   "motion": "cleave"
  },
  "3EFE01FD-B30C-4E5B-A9D5-73EFE8ADF57A": {
   "name": "Corporeal Instability",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8820328B-01FA-DA63-6C18-013836D42196": {
   "name": "Drowning Whirlpool",
   "type": "ability",
   "motion": "whirl"
  },
  "7805C767-66D1-E6CE-AABF-210B50742743": {
   "name": "Syphoning Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EE15749C-695C-7F49-93C2-39D9A91261DE": {
   "name": "Mind-Rending Spike",
   "type": "attack_ability",
   "motion": "thrust"
  },
  "AD8DDD18-C8CA-671F-D477-8B996DF857DF": {
   "name": "Cleaving Slam (10) (4d10)",
   "type": "ability",
   "motion": "cleave"
  },
  "E54B3FFF-F6AF-A0AC-A69C-D6B6383F0E13": {
   "name": "Shardline Cut",
   "type": "quick_ability",
   "motion": "basic"
  },
  "9F416BAC-4197-68CA-052F-1E328E71C104": {
   "name": "Reflected Blow",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "DFB39F9A-CBDD-0A03-1998-C9B39D432A4F": {
   "name": "Feather Flurry (60) (4d8)",
   "type": "ability",
   "motion": "flurry"
  },
  "670C1F02-1A14-A778-C01D-80606F326CBB": {
   "name": "Shocking Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "7E25574D-7764-6D71-8BA8-B1B156DD1DB8": {
   "name": "Holy Turning Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "442B805C-9DF5-ABE0-3535-33F524B0C271": {
   "name": "Ballista Bolt (60) (d6)",
   "type": "ability",
   "motion": "shot"
  },
  "673A381B-432B-E3A0-8AD7-D9BB2434CE45": {
   "name": "Sandstorm Burst (Sphere 60)",
   "type": "ability",
   "motion": "battlecry"
  },
  "224D9972-B5BD-651B-CCAA-FD408FBF5F10": {
   "name": "Compelling Attack",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2CC93427-BAE3-3F64-670B-48B6263991B3": {
   "name": "Mana-Draining Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9E7CDB65-3B5F-5431-71E0-E17587869002": {
   "name": "Frostbiting Slam",
   "type": "attack_ability",
   "motion": "smash"
  },
  "7B53D533-6CD0-86F4-1A49-3B95DDE42B81": {
   "name": "Withering Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "6236CA4B-0EC2-4CAE-2113-2E05F325716E": {
   "name": "Warding Tail",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "3A3CFB81-27CA-3C00-DC03-00C3D0EDEE33": {
   "name": "Restraining Tail Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "3C0FEA11-CF52-C371-682F-9FC3564CD5D2": {
   "name": "Crushing Jaws",
   "type": "ability",
   "motion": "smash"
  },
  "272C06C6-97E2-5E05-A99E-FCDC443EA72C": {
   "name": "Salt Breath Weapon (25) (1d10)",
   "type": "ability",
   "motion": "basic"
  },
  "27BEA8BB-67F2-AFA0-5E42-6B840DA4A54F": {
   "name": "Salt Breath Weapon (40) (2d10)",
   "type": "ability",
   "motion": "basic"
  },
  "64E905DC-7E47-000E-29F6-67E842B62F80": {
   "name": "Salt Breath Weapon (80) (3d10)",
   "type": "ability",
   "motion": "basic"
  },
  "57A2ACB5-52A4-0E41-508B-B068511A9C3D": {
   "name": "Salt Breath Weapon (120) (4d10)",
   "type": "ability",
   "motion": "basic"
  },
  "220E15DB-DCA9-BA1F-4475-8B874FA79D7F": {
   "name": "Igniting Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C1D10B0F-9FE4-5FEC-D618-37C63078C4CC": {
   "name": "Debris Burst",
   "type": "ability",
   "motion": "basic"
  },
  "E8F107CA-5F61-9491-2116-54DAA241A2C1": {
   "name": "Impaling Charge (6d8)",
   "type": "attack_ability",
   "motion": "charge"
  },
  "0C1A567D-B466-535C-449C-1D57C6BBCD72": {
   "name": "Constricting Crush (3d8)",
   "type": "attack_ability",
   "motion": "smash"
  },
  "24C92221-7D44-9DE8-8D86-C8500EBC2DD9": {
   "name": "Grappling Rider",
   "type": "attack_ability",
   "motion": "basic"
  },
  "09C42A7C-3200-2AA7-3EC9-1911F82F43BC": {
   "name": "Blighting Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "DC52CE35-5280-1D39-A8C4-587DCE297E42": {
   "name": "Nature's Wrath (6d8)",
   "type": "ability",
   "motion": "smash"
  },
  "68A7E298-C465-05AF-7721-6120581CC27F": {
   "name": "Salt Breath Weapon (180) (6d10)",
   "type": "ability",
   "motion": "basic"
  },
  "E476922F-AADF-C577-16E6-3ADFE4697F74": {
   "name": "Molten Sand Breath (120) (18d8)",
   "type": "ability",
   "motion": "smash"
  },
  "2E412394-AA2C-A860-C1A3-62D412989F14": {
   "name": "Impaling Bolt",
   "type": "full_ability",
   "motion": "shot"
  },
  "ECDDB7CB-BDE6-0C2D-6A9D-E4A8157F3FC3": {
   "name": "Scorpion Bolt",
   "type": "ability",
   "motion": "shot"
  },
  "6D5AD694-ADB7-2764-E32A-FD851A9778B0": {
   "name": "Counterweight Stone",
   "type": "full_ability",
   "motion": "parry"
  },
  "7754C85C-72F9-9BF3-F654-9EC35C45B696": {
   "name": "Ram the Gate",
   "type": "full_ability",
   "motion": "basic"
  },
  "CB26336A-E307-6DFB-CCFF-F12F449F2F9C": {
   "name": "Fire Bombard",
   "type": "full_ability",
   "motion": "shot"
  },
  "1C5BD9F5-8916-7BD6-57F4-3E4290FFB3E9": {
   "name": "Blighting Drain",
   "type": "attack_ability",
   "motion": "basic"
  },
  "AFA7757B-8BF7-7CF1-EF27-446DCCEA0D44": {
   "name": "Cratering Boulder",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "FF503397-B829-453A-964A-B8D2BAAB32E4": {
   "name": "Cannon Shot",
   "type": "full_ability",
   "motion": "shot"
  },
  "52DA0E78-12D8-4AE7-AAE8-6206278A1C5E": {
   "name": "Grapeshot",
   "type": "full_ability",
   "motion": "charge"
  },
  "EE4BED17-8991-4887-183D-7DB791ED38C3": {
   "name": "Exhausting Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A13A0316-F7C9-5CA9-E9EA-02771C020F08": {
   "name": "Deadening Frost",
   "type": "attack_ability",
   "motion": "basic"
  },
  "9D553AFA-786E-2102-BE85-6178841C8C60": {
   "name": "Blinding Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "CB74184F-C4A0-92F3-01B5-B2F8483D076A": {
   "name": "Ensnaring Tendrils",
   "type": "attack_ability",
   "motion": "basic"
  },
  "331DB5BF-B200-4B4A-57AE-3C3D7E1BA503": {
   "name": "Charge (2d8)",
   "type": "attack_ability",
   "motion": "charge"
  },
  "6D68B086-B6AC-C96E-8F48-B44E44036AB6": {
   "name": "Metal Storm",
   "type": "ability",
   "motion": "whirl"
  },
  "261A9F3B-15CC-2770-3546-7152FB0736CE": {
   "name": "Ensnaring Lash",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5EDF570D-9155-8748-65B9-450A25F31EB5": {
   "name": "Rictus Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "62043716-17DC-8B50-937D-B06203D71A61": {
   "name": "Numbing Chill",
   "type": "attack_ability",
   "motion": "parry"
  },
  "2CB3E4BE-EE96-2BD0-90E1-C3DBD53A5E07": {
   "name": "Unmaking Wound",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C9CA50D5-9AF1-A7D1-0696-8816AF500D84": {
   "name": "Wing Buffet",
   "type": "ability",
   "motion": "smash"
  },
  "C6BC4B71-3FF9-F63D-051F-2D6605AC7B64": {
   "name": "Pain Frenzy",
   "type": "ability",
   "motion": "whirl"
  },
  "A3C4B7AF-1B50-A2AF-0877-B35814E7C27C": {
   "name": "Crushing Hold",
   "type": "ability",
   "motion": "smash"
  },
  "C1CB2E26-8AA9-F425-7D91-D5833ED13E9D": {
   "name": "Trample (60) (2d8)",
   "type": "ability",
   "motion": "charge"
  },
  "E6F63C3A-BAC9-01BA-E33A-76668B518665": {
   "name": "Chill Embrace",
   "type": "ability",
   "motion": "smash"
  },
  "D7E76723-7ECC-9B74-2D7E-C99DD566ABB5": {
   "name": "Wracking Fungal Toxin",
   "type": "attack_ability",
   "motion": "basic"
  },
  "B73FFF58-2456-5A51-AFD6-2C22E910DA63": {
   "name": "Rolling Charge",
   "type": "ability",
   "motion": "charge"
  },
  "FDDF09F4-9386-C300-9DB0-D1B6E176339C": {
   "name": "Paralyzing Venom",
   "type": "attack_ability",
   "motion": "basic"
  },
  "F67B217C-A30F-3E3C-2D4C-899F2C94712B": {
   "name": "Mind-Reeling Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "2B723A44-B111-48D6-95BC-0F19966BE4D1": {
   "name": "Cleaving Strike (2)",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "BD2E62AC-5E92-51D2-03D9-CAE7224A778D": {
   "name": "Venomous Spines",
   "type": "ability",
   "motion": "whirl"
  },
  "3426D14B-03BD-7365-92ED-E70900FEFFA1": {
   "name": "Awakening: Thousand Angle Reversal",
   "type": "full_ability",
   "motion": "basic"
  },
  "925F832E-9341-6140-C3EB-A21FEF58C04B": {
   "name": "Studied Reversal",
   "type": "opportunity_attack_ability",
   "motion": "basic"
  },
  "881DA489-924E-A21E-A185-D66106262BAB": {
   "name": "Glassbreaker Bash",
   "type": "quick_ability",
   "motion": "shield_bash"
  },
  "95404A7F-E31B-5358-161E-E94CF11AA61C": {
   "name": "Mirrorline Execution",
   "type": "ability",
   "motion": "finisher"
  },
  "32F4D1F2-8165-F25B-54F1-573E46C5600F": {
   "name": "Strangle",
   "type": "ability",
   "motion": "smash"
  },
  "8E54CAE5-4851-E89F-DDD8-8A1D5B4F667F": {
   "name": "Lashing Whirlwind",
   "type": "ability",
   "motion": "whirl"
  },
  "C2D7D680-CC53-58AB-CC91-71F043D06F9A": {
   "name": "Pressure Spit (60)",
   "type": "ability",
   "motion": "smash"
  },
  "982F99C8-A28C-1F21-DB85-87B5A97764A9": {
   "name": "Rending Follow-Through",
   "type": "attack_ability",
   "motion": "basic"
  },
  "5D99877E-C52E-6BB0-DF50-81D6BD1E3222": {
   "name": "Hurl Stone",
   "type": "quick_ability",
   "motion": "parry"
  },
  "D8C83913-BC02-381F-3A8B-BF566F282E82": {
   "name": "Hurl Captive",
   "type": "quick_ability",
   "motion": "shove"
  },
  "2B1186B2-6F44-5E97-F8B7-051A451F57C2": {
   "name": "Eye Drinking",
   "type": "attack_ability",
   "motion": "basic"
  },
  "97FB8249-CE72-5D1A-50E7-B365EE6F5A20": {
   "name": "Soulwrack Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "421E88FF-29F1-3F03-5E7E-10D67A13EC5B": {
   "name": "Trampling Charge",
   "type": "quick_ability",
   "motion": "charge"
  },
  "FFB74618-F52C-13A0-F8ED-FC330169D2C9": {
   "name": "Bucking Kick",
   "type": "reaction_ability",
   "motion": "kick"
  },
  "0D495F92-ABB8-06CC-9C54-F877A5BB5236": {
   "name": "Charging Impact",
   "type": "ability",
   "motion": "stance"
  },
  "8C64A153-D99E-1889-DF40-00229C4E8D69": {
   "name": "Spine Volley",
   "type": "ability",
   "motion": "whirl"
  },
  "D69823C9-C8BC-60EC-8D6B-ADA7BD8BC5A0": {
   "name": "Glass Breath (20)",
   "type": "ability",
   "motion": "whirl"
  },
  "FC1727D6-A48A-DED4-4747-A9AF935CA675": {
   "name": "Grave Blight Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C8453617-0B32-000E-B2E1-CC84D5BC47AC": {
   "name": "Awakening: First Blood Release",
   "type": "full_ability",
   "motion": "basic"
  },
  "5523AC8D-4A03-E2E8-69B4-37A774E2F011": {
   "name": "Red Mist Rush",
   "type": "ability",
   "motion": "charge"
  },
  "63F16060-61EF-9A51-8494-BD4493C51DA2": {
   "name": "Blood-Hound Pursuit",
   "type": "ability",
   "motion": "basic"
  },
  "22B5FF14-0488-854E-766D-FC62725DD08B": {
   "name": "Awakening: Familiar Restraint Release",
   "type": "full_ability",
   "motion": "basic"
  },
  "ADA0F20F-8FCE-22C7-DA71-424825A93437": {
   "name": "Thrown Boulder",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "D7FF095F-B646-8742-549B-0B5C12CFABD1": {
   "name": "Obsidian Shard Edging",
   "type": "attack_ability",
   "motion": "smash"
  },
  "C2A85AC1-43D1-2059-4066-05E4F3B6539A": {
   "name": "Siphoning Bite",
   "type": "attack_ability",
   "motion": "basic"
  },
  "50079006-221C-9939-7131-07C0E722FAE4": {
   "name": "Toppling Blow",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "105D8338-223A-E979-BE5C-4B11EE607412": {
   "name": "Toppling Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "EF733D4D-7A24-984B-E807-E819C4071A39": {
   "name": "Diving Swoop",
   "type": "attack_ability",
   "motion": "charge"
  },
  "57292A1E-D104-371C-DD2A-223BC8A2F66D": {
   "name": "Spirit-Numbing Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "06CFEF8A-7A78-4020-9EAC-9A653B4ED2F1": {
   "name": "Soul-Sapping Strike",
   "type": "attack_ability",
   "motion": "basic"
  },
  "C1A2EE92-07DF-4EA0-32C8-4216368741C6": {
   "name": "Ranged Opportunity Shot",
   "type": "opportunity_attack_ability",
   "motion": "shot"
  },
  "C8E080B9-DE5D-93FD-A803-5FA90339FF05": {
   "name": "Volley",
   "type": "ability",
   "motion": "shot"
  },
  "24802859-6E45-FC70-67A3-DC3F5AD6A722": {
   "name": "Reaving Sweep",
   "type": "attack_ability",
   "motion": "cleave"
  },
  "1A59FC6E-88D1-0E69-659E-B5F9EFFDC7BD": {
   "name": "Unnatural Grasp",
   "type": "attack_ability",
   "motion": "basic"
  },
  "4075CDDC-66ED-ED17-B735-A74F763321B3": {
   "name": "Release Seed Pod",
   "type": "ability",
   "motion": "gesture"
  },
  "A9575848-EFC0-E1E9-19BC-A738719AD67A": {
   "name": "Mind-Locking Grasp",
   "type": "attack_ability",
   "motion": "basic"
  },
  "8E7C978F-4AAA-EC4A-DE50-82E231EBE00A": {
   "name": "Extract Brain (6d8)",
   "type": "ability",
   "motion": "finisher"
  },
  "BA9DFBCD-6C68-EC31-F51F-1BEE3AC1FD40": {
   "name": "Extract Brain (8d10)",
   "type": "ability",
   "motion": "finisher"
  },
  "F3CA4658-E897-4FEC-2792-C079751D5650": {
   "name": "Extract Brain (10d10)",
   "type": "ability",
   "motion": "finisher"
  },
  "97DADAF3-665F-841C-FD52-E5B29AD55F77": {
   "name": "Extract Brain (12d10)",
   "type": "ability",
   "motion": "finisher"
  },
  "38C13823-EB24-1DC3-F49E-8FFF8E3B5A21": {
   "name": "Extract Brain (14d10)",
   "type": "ability",
   "motion": "finisher"
  },
  "9DCF8247-8CD6-4090-CD71-404744A201A9": {
   "name": "Oversized Draw",
   "type": "attack_ability",
   "motion": "basic"
  },
  "59039AD0-FB4A-07B5-9697-BEADB32224A1": {
   "name": "Hurled Timber Spear",
   "type": "ability",
   "motion": "thrust"
  },
  "A4AFF75C-2265-3BB5-FB57-DD1C87D82D9A": {
   "name": "Shard Volley",
   "type": "quick_ability",
   "motion": "basic"
  },
  "72C08694-FF22-6D58-DA32-66DDC5ADD16C": {
   "name": "Glass Splinter (2d4)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "FE4FA521-AA92-6B1E-7785-753D8B9D397F": {
   "name": "Glass Splinter (2d8)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "66B8834E-1FB7-FA48-E0B3-7CB6DF953DAA": {
   "name": "Shardfall",
   "type": "ability",
   "motion": "basic"
  },
  "4B9FEF50-3668-7C1B-A26C-319C1B8F099C": {
   "name": "Glass Corridor",
   "type": "ability",
   "motion": "basic"
  },
  "77327F58-6BFD-6662-182C-4F69502C2F26": {
   "name": "Crystal Spike (4d8)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "98E9C886-EE94-0786-28CC-ECEFC50F33BF": {
   "name": "Crystal Shackles",
   "type": "full_ability",
   "motion": "basic"
  },
  "C8533A55-71A2-F4E3-3D84-76EEF1C1E8BD": {
   "name": "Reflective Escape",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "AA38966B-F4A9-AAD9-6E4B-1EB783E40E45": {
   "name": "Crystal Spike (5d8)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "05188701-40FA-4619-48AC-2D05F614B7DE": {
   "name": "Refraction Maelstrom",
   "type": "full_ability",
   "motion": "whirl"
  },
  "8303738C-89DE-1450-BE84-7BC3BE638B8C": {
   "name": "Mirror Gate Strike",
   "type": "ability",
   "motion": "basic"
  },
  "F12D9DAD-23EA-93E4-02AD-935FEDF18773": {
   "name": "Mana Splinter Storm",
   "type": "full_ability",
   "motion": "charge"
  },
  "BE938EC1-F346-802A-9171-90E5437BCF79": {
   "name": "Crystal Spike (6d8)",
   "type": "quick_ability",
   "motion": "basic"
  },
  "B34F401C-078E-6F74-CB38-171707985C08": {
   "name": "Aureate Mirrorstorm",
   "type": "full_ability",
   "motion": "basic"
  },
  "C6BE1A25-1571-0E80-A693-DFC1EBBCAA24": {
   "name": "Thunderhoof",
   "type": "quick_ability",
   "motion": "charge"
  },
  "5CDE4121-7995-6401-7317-0FEAFA58DCA4": {
   "name": "Horn Charge",
   "type": "ability",
   "motion": "charge"
  },
  "B4FCA6D7-1094-BC69-1C65-4DCC256AEB86": {
   "name": "Greater Thunderhoof",
   "type": "quick_ability",
   "motion": "charge"
  },
  "9AB452DC-7A90-563A-71F2-A61CB8BA1CD4": {
   "name": "Thunderhorn Rush",
   "type": "ability",
   "motion": "charge"
  },
  "A7D2C61D-78B8-E4A0-A5AD-BFEDB3FAF149": {
   "name": "High Thunderhoof",
   "type": "quick_ability",
   "motion": "kick"
  },
  "0A228B55-060E-7F1C-8779-C102896A13F8": {
   "name": "True Thunderhoof",
   "type": "quick_ability",
   "motion": "kick"
  },
  "733EA629-7E45-9628-7D98-0B15A22E2DF6": {
   "name": "Legendary Thunderhoof",
   "type": "quick_ability",
   "motion": "kick"
  },
  "72587E4A-3CFD-FFAE-408A-6B8952D1876A": {
   "name": "Septic Needle",
   "type": "ability",
   "motion": "basic"
  },
  "6921905D-478B-1442-E3B7-550AF6EC7EB4": {
   "name": "Septic Impalement",
   "type": "ability",
   "motion": "thrust"
  },
  "1FBCEDD5-98BD-D484-6A91-C828BB1B62DB": {
   "name": "Paralytic Impalement",
   "type": "ability",
   "motion": "thrust"
  },
  "8F6E9748-2652-6ACF-FB70-18B49D1540B1": {
   "name": "Graveyard Smash",
   "type": "ability",
   "motion": "smash"
  },
  "4EBA0C5E-5674-C220-4921-666F16C2C593": {
   "name": "Coffin Slam",
   "type": "attack_ability",
   "motion": "smash"
  },
  "EB98F223-AD8E-0C8C-13B8-A1C06A4AA69E": {
   "name": "Shell Breaker",
   "type": "ability",
   "motion": "thrust"
  },
  "CDAC9E31-2F4C-73A9-DF13-1DA32305B85F": {
   "name": "Tentacle Drag (25)",
   "type": "attack_ability",
   "motion": "basic"
  },
  "A3CA03FE-8AD1-2B92-7FC0-D6579C9449DC": {
   "name": "Bombard Lob",
   "type": "full_ability",
   "motion": "charge"
  },
  "31A6EE88-E60D-6B48-2979-2744FAAE7FDD": {
   "name": "Vine Blade",
   "type": "ability",
   "motion": "whirl"
  },
  "01B9C5FE-6121-C92E-CEC4-AE815DFAE280": {
   "name": "Stonesense",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "5EB2C647-F1FD-4243-4A72-16D468C6D4AF": {
   "name": "Endurance of the Stone Giant",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "F622A10E-3025-7631-3699-A062329FF4F2": {
   "name": "Interposing Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "AFB2DB07-B061-CD62-1693-9A9EF445F2F4": {
   "name": "Bait and Switch",
   "type": "quick_ability",
   "motion": "basic"
  },
  "A2A6553B-B4AF-695A-265D-5941F5AAA23E": {
   "name": "Masterful Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "89FB9FD8-CAF6-8ECE-998F-0F861A4A156E": {
   "name": "Embedded Weapon Retract",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "393EE356-EA3B-D9EB-F7FB-AC4E95B89E5B": {
   "name": "Dwarven Footing",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "4DB5BCCE-3398-DB58-6830-6A83AE2E4D47": {
   "name": "Immovable Item",
   "type": "ability",
   "motion": "gesture"
  },
  "89454C0E-0024-B701-53CF-4EBC96E39EF5": {
   "name": "Shield Protector of Meotl",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "1DDA910A-2D42-204A-F804-D520F0311B08": {
   "name": "Retractable Blade",
   "type": "ability",
   "motion": "gesture"
  },
  "4C2FBE7C-20EC-92C2-30E3-8B6A82E5791C": {
   "name": "Plant Magic Bean",
   "type": "ability",
   "motion": "gesture"
  },
  "87BBBB88-064C-D38D-8BC4-4898EA0EF34D": {
   "name": "Bag of Devouring Yum Yum Time",
   "type": "ability",
   "motion": "gesture"
  },
  "77070C41-111A-9A35-98EB-B184CB275165": {
   "name": "Shackle Creature with Dimensional Shackles",
   "type": "ability",
   "motion": "gesture"
  },
  "B0C8A0A8-64C0-0E16-B004-180E2F5AE9CD": {
   "name": "Swarm Consciousness",
   "type": "ability",
   "motion": "gesture"
  },
  "44A715AD-48FD-EEB0-BCFB-28621B168CE3": {
   "name": "Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "A867D4D0-3A72-FE29-3D8F-207F2E4B979C": {
   "name": "Goblin Redirect Attack",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "91EDA075-D90F-04F9-8152-9FD40DD4BF72": {
   "name": "Inspiring Leadership",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "7B09E094-E737-DFFC-480D-60581FAB6B2F": {
   "name": "Shield Guardian Protector",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "D92A3B3A-90A9-69E3-4E37-AE06662C8A19": {
   "name": "Rock Catching",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "0B7636F2-F428-28FE-D84B-8E6862C43FA2": {
   "name": "Deflect Attack",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "9EB6B5C7-80D4-F764-CA12-EEDECDB6E67C": {
   "name": "Grinding Halt",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "D8FFA111-6A29-FC20-6368-D2B12C7B5D73": {
   "name": "Lock Blades",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "7938988E-041B-99D2-ECE8-4A25F8E3CA56": {
   "name": "Gauche Feint",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "15792C29-F29F-2ACD-B499-CC7AB6BA83D7": {
   "name": "Disarming Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "59697E52-445A-85E8-81B2-3C55A702B92F": {
   "name": "Piercing Point",
   "type": "quick_ability",
   "motion": "basic"
  },
  "49AF727D-1361-0DF4-C040-AA1260B8C7D8": {
   "name": "Concealed Weapon",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "F693EECE-4A7E-66C7-034F-D39E1F247C43": {
   "name": "Catchy Performance",
   "type": "ability",
   "motion": "gesture"
  },
  "8A26584E-9609-4D66-C6DC-4D902FB67723": {
   "name": "A King's Delicacy",
   "type": "ability",
   "motion": "gesture"
  },
  "8B56391E-E70C-F70E-A8BD-F9E4D54DA577": {
   "name": "Fast Dipper",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "D47921D8-EA9B-6B07-0667-95061CE8A10F": {
   "name": "Sacrificial Shield",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "F1E88C02-CA27-4275-AC4C-7284B1B55FAC": {
   "name": "Deployable",
   "type": "ability",
   "motion": "gesture"
  },
  "00B85B97-1C34-4D6C-A4FC-E4A70849A6DC": {
   "name": "Shield Wall",
   "type": "quick_ability",
   "motion": "stance"
  },
  "D01EE29B-9BCF-47FE-A173-4D70B3C78135": {
   "name": "Derendian Moth Lay Egg",
   "type": "ability",
   "motion": "gesture"
  },
  "01E14E9A-1795-4346-8059-A55E4C7A2381": {
   "name": "Unparalleled Resolve",
   "type": "full_ability",
   "motion": "stance"
  },
  "28A63861-F546-BFCD-62CE-29DFDABECD70": {
   "name": "Embedded Weapon Extract",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "13F13D44-3DAD-4839-B739-7B6DC436FBE1": {
   "name": "Subtle Stride",
   "type": "quick_ability",
   "motion": "stance"
  },
  "C60FE891-7156-47E5-A945-E02F18F5AAEC": {
   "name": "Steadfast Posture",
   "type": "quick_ability",
   "motion": "stance"
  },
  "FF5949E9-DC8D-4628-A634-84A2C79AA9FB": {
   "name": "Agile Dodge",
   "type": "quick_ability",
   "motion": "stance"
  },
  "7A0A9D30-61AC-40BE-9DF1-DCE2336C3E58": {
   "name": "Agile Centering",
   "type": "quick_ability",
   "motion": "stance"
  },
  "41242BF8-3946-4CB7-A429-E5BA7DB8CF5B": {
   "name": "Sturdy Resolve",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "91DEC979-E5F2-47F6-56B5-967E29100F2C": {
   "name": "Hidden Steel Curtain",
   "type": "quick_ability",
   "motion": "stance"
  },
  "9DA7A18E-EE6F-98C9-ABD0-39B35F0AB2EF": {
   "name": "Steel Curtain",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "BF55A97B-498F-4122-AF11-71F08585CF55": {
   "name": "Unshakable Defense",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "9900BCAA-0380-4F47-BB6D-C17EC0D0AC34": {
   "name": "Solid Armament",
   "type": "quick_ability",
   "motion": "stance"
  },
  "4F22A048-E3CE-45A6-AE86-02EAFED20E00": {
   "name": "Critical Absorption",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "E3C04003-AEE1-45B5-B36D-BBFDFDD86D1F": {
   "name": "For the Maw",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "9C04B31C-5032-4E22-8BBA-6D175F722D3D": {
   "name": "Ogre Inspiration",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "0213F145-3331-474D-BE0A-E4F142C19779": {
   "name": "Shell Retreat",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "3CC6D3EF-69E2-4ECA-A673-A3AD85112F39": {
   "name": "Attention to Detail",
   "type": "full_ability",
   "motion": "basic"
  },
  "D66DBA3E-31DB-B2C5-B522-200E14B61841": {
   "name": "Quick Look",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "69477971-232F-9AE0-9737-31EEB365DABD": {
   "name": "Balancing Act",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "5576139A-6DE9-8F09-1F11-9DCE390DA318": {
   "name": "Graceful Tumble",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "BEA93406-C330-42B6-B57D-41BA48AD79D3": {
   "name": "Consume Scrap Hand",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "BD926182-282D-4ECA-97A6-5BBE27A2C219": {
   "name": "Dual Wield Defense",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "119E0506-5D8C-4986-B196-B7C448604BF5": {
   "name": "Unsettling Laughter",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "8B7E17A9-3B2E-4153-A070-4B4C2D1E0E18": {
   "name": "Snack Break",
   "type": "ability",
   "motion": "gesture"
  },
  "B6498A26-DCF3-4D40-9C6B-16CC785418C4": {
   "name": "Ready to Duck",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "F3B2E342-544E-4EAB-A61B-815FCCAD3E54": {
   "name": "Battlefield Order",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "B93573F4-D627-48BA-83C6-D149AEB289FA": {
   "name": "Off-Balance Feint",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "DCF62544-91D1-4B98-B275-8859B5C6B6B7": {
   "name": "Guarded Assault",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "CD8FEF2A-94BD-4073-B3BA-537B2B5FED34": {
   "name": "Defensive Bulwark",
   "type": "quick_ability",
   "motion": "stance"
  },
  "683D98FA-3EA2-4CFA-A8C8-77E1FB23215B": {
   "name": "Sweeping Guard",
   "type": "quick_ability",
   "motion": "parry"
  },
  "EFC3CB70-B502-459D-A60F-6A44195C1CA5": {
   "name": "Light Hand Lamp",
   "type": "full_ability",
   "motion": "gesture"
  },
  "DE99838F-DCC7-DF81-D4B2-48ADA2A97262": {
   "name": "Light Hooded Lantern",
   "type": "full_ability",
   "motion": "gesture"
  },
  "634BE906-3321-4CA1-9C01-E7D07CDFF10F": {
   "name": "Light Candle",
   "type": "full_ability",
   "motion": "gesture"
  },
  "D9C8AD45-023D-0F08-18E1-12D6C21BF0E0": {
   "name": "Light Torch",
   "type": "full_ability",
   "motion": "gesture"
  },
  "4AAB51D1-370B-4EC3-9009-8DB369C84CDF": {
   "name": "Light Taper Candle",
   "type": "full_ability",
   "motion": "gesture"
  },
  "B46E6FD6-32A6-FD02-40CA-D66C9A194FFF": {
   "name": "Light Pillar Candle",
   "type": "full_ability",
   "motion": "gesture"
  },
  "33D68A90-29BE-45DB-86F1-64CE47A60DFF": {
   "name": "Ravenous Gorge",
   "type": "full_ability",
   "motion": "gesture"
  },
  "5A01CC90-3A4C-4003-A711-38E6A2F4C479": {
   "name": "Release Elemental Energy",
   "type": "quick_ability",
   "motion": "basic"
  },
  "9726D6DC-9E75-49E1-8B8C-C62F3A8674EF": {
   "name": "Quill Defense",
   "type": "ability",
   "motion": "stance"
  },
  "497D1EC3-5D70-4344-96C0-790C15542359": {
   "name": "Pull Quill Out",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "4AC963F7-EE1C-4791-B84F-59E5E8848519": {
   "name": "Dance of Blades",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "6BFAE5D3-9040-D8B8-4A83-1603F9C2C729": {
   "name": "Agile Deflection",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "8BA69C40-9191-8AF6-D521-5BF6A31F989E": {
   "name": "Legendary Defenses",
   "type": "ability",
   "motion": "stance"
  },
  "F9C8ACB8-48EB-488B-C9CE-DFDD6E27F5F9": {
   "name": "Burst of Speed",
   "type": "quick_ability",
   "motion": "basic"
  },
  "C90BC346-58CE-F320-8C19-B78C62EE51A3": {
   "name": "Tactical Withdrawal",
   "type": "ability",
   "motion": "battlecry"
  },
  "9A0CFF2C-4325-9415-CF0A-82BAB9EF0FBC": {
   "name": "Focused Assault",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "9CFBB9ED-E539-6A5F-46A6-D0DE72281AB2": {
   "name": "Pickpocket",
   "type": "ability",
   "motion": "gesture"
  },
  "3097FACE-7132-6AA0-807F-359D6F7C3BC0": {
   "name": "Light Campfire",
   "type": "full_ability",
   "motion": "gesture"
  },
  "9EB1A04A-C704-D77C-EAA6-0C235796AB09": {
   "name": "Tanuki Block!",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "C58DB18A-A58A-E33E-15C5-9745AFB0430E": {
   "name": "Awaken from Slumber of the Watcher",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "CD4AFF7B-222D-85CC-ECC8-16AEA9F286AF": {
   "name": "Stone Eater",
   "type": "ability",
   "motion": "gesture"
  },
  "A6F3D62E-C220-40DD-9B3C-D3B74C32D8E1": {
   "name": "Ungodly Recoil",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "6E24BBC0-C477-2D88-9858-073004DF5EBA": {
   "name": "Precision Lock",
   "type": "quick_ability",
   "motion": "stance"
  },
  "B042AA3A-8CC5-D375-0898-B8A373C689A3": {
   "name": "Wrist Deflection",
   "type": "quick_ability",
   "motion": "parry"
  },
  "8A7CE886-5AE9-5FED-4716-819F183728F1": {
   "name": "Deflective Arc",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "E5392D43-1EBC-6015-D0F9-758BF782CA55": {
   "name": "Counterbeat",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "6A38DDFA-683F-F235-118C-2512AB4CE194": {
   "name": "Standard Block",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "78738920-2388-3871-AD1E-778639E764F1": {
   "name": "Iron Rebound",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "668B725D-BDFF-6141-B6EB-806FB0101D92": {
   "name": "Immortal Tenacity",
   "type": "quick_ability",
   "motion": "stance"
  },
  "B0A473D3-43EC-2108-7ACF-3F1FD4D1B8BB": {
   "name": "Lucid Focus",
   "type": "quick_ability",
   "motion": "stance"
  },
  "07110EFB-0781-5961-3031-22C42113AEFD": {
   "name": "Mindwall Discipline",
   "type": "quick_ability",
   "motion": "stance"
  },
  "AE80A34B-56D6-15B0-2D71-93F13CE1FAED": {
   "name": "Hooked Yank",
   "type": "quick_ability",
   "motion": "basic"
  },
  "EA3067C7-7C4E-4123-30D6-959666968A4A": {
   "name": "Fang Dance",
   "type": "quick_ability",
   "motion": "stance"
  },
  "4927F1CB-D18B-515E-AEB7-87663E12C783": {
   "name": "Edge Feint",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "1CB23DFD-A404-D978-4577-BA40F3C38E16": {
   "name": "Curved Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "5895007B-707D-3CDB-5348-99AA1C8E8A11": {
   "name": "Vault Step",
   "type": "quick_ability",
   "motion": "basic"
  },
  "D3C705CB-0676-E912-6816-D06FC6395152": {
   "name": "Whirling Guard",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "C46272D2-6206-AAD1-825B-50EAD574515A": {
   "name": "Weighted Step",
   "type": "reaction_ability",
   "motion": "stance"
  },
  "D6C0649C-2118-0B7E-473F-96415B7221C7": {
   "name": "Deflecting Haft",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "3DB81A31-2648-3319-34AB-9C07EEA06432": {
   "name": "Whirling Haze",
   "type": "quick_ability",
   "motion": "basic"
  },
  "0E17B7D0-6DE8-BEC5-7DBE-13F3BBBA3290": {
   "name": "Cross-Guard Catch",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "B1292DFA-FEED-117B-030F-D7756064329D": {
   "name": "Feint Release",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "95C14166-A52A-1CFF-93B5-F289B549BCA4": {
   "name": "Draw-and-Fade",
   "type": "quick_ability",
   "motion": "basic"
  },
  "052A34F5-04D0-20BF-972E-7C9A4687D06A": {
   "name": "Bow Bash",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "52494953-D831-BCF7-8CB2-9176E1515CB1": {
   "name": "Overdraw",
   "type": "quick_ability",
   "motion": "stance"
  },
  "51C1F866-6F7E-276C-3B43-3EC5FA483174": {
   "name": "Signal Stop",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "524F630A-E0ED-D2AA-9C3D-AAC6C23E919C": {
   "name": "Clash of Focus",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "810C9C6E-29D6-1775-B44E-895CC1BDFBCC": {
   "name": "Piercing Melody",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "327FFEBD-291D-FE26-6C20-EC7CEF817E77": {
   "name": "Heartstrings",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "AD9A95D0-5593-BF85-593F-99E914A3C37C": {
   "name": "Commanding Vibrato",
   "type": "ability",
   "motion": "gesture"
  },
  "E5CA326F-1D13-9088-25DB-C90DAEABF189": {
   "name": "Grand Finale",
   "type": "full_ability",
   "motion": "gesture"
  },
  "2B0D4D5B-AA90-B4FF-0007-B91C47F15CE1": {
   "name": "Coin-Flip Stinger",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "BFB6309C-429F-36FF-FFAD-947D3CCAD89D": {
   "name": "Pastoral Drift",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "ED66B7E7-A88C-3FC2-F250-155293198B5B": {
   "name": "Wind-Veiled Step",
   "type": "ability",
   "motion": "gesture"
  },
  "37E82EA0-F995-4410-63D2-D089CC13C4E5": {
   "name": "Sharp Attack",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "65041C11-A268-BFA3-3D51-260FFF94F4B7": {
   "name": "Cutting Vibrato",
   "type": "ability",
   "motion": "gesture"
  },
  "D2A0689C-66EE-D319-A0AE-5E2F17E0B26F": {
   "name": "Subtle Warning",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "40BE2316-EA5F-468B-AD2A-008EC45D3F25": {
   "name": "Harmony of Consensus",
   "type": "ability",
   "motion": "gesture"
  },
  "2C4E325B-3AD9-61C6-427D-3342BD06EA83": {
   "name": "Petalguard",
   "type": "quick_ability",
   "motion": "stance"
  },
  "D839AEB0-C8D4-DA3F-E0CE-97A0232E1660": {
   "name": "Whirling Canopy",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "ACEFC03F-2C17-BACC-96F2-62002AE31758": {
   "name": "Pendulum Guard",
   "type": "quick_ability",
   "motion": "stance"
  },
  "B6E488A6-BC27-0B8B-981B-E480F2247438": {
   "name": "Cross-Arm Parry",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "A62559F9-1FE1-C335-E173-73557B9D7ACA": {
   "name": "Pulled Punch Feint",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "7058AE5E-F983-9ECB-A850-D4F685ACACAB": {
   "name": "Anchor of the Giant",
   "type": "quick_ability",
   "motion": "stance"
  },
  "76173042-0530-C12A-1305-A1D22635E90F": {
   "name": "Ripper's Guard",
   "type": "quick_ability",
   "motion": "stance"
  },
  "D69DD5A4-D1DF-FD66-2CB1-CA9DB60073EB": {
   "name": "Shoulder-Braced Guard",
   "type": "quick_ability",
   "motion": "stance"
  },
  "EE80E1D0-2AD6-B16A-2B63-ACD2C533B6E6": {
   "name": "Skyhook Arrow",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "3928DDE7-42EF-1CFF-57D9-624A7CABD4ED": {
   "name": "Wave the Banner",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "4001F16B-9476-810A-8B33-F7818F283660": {
   "name": "Dramatic Reversal",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "C18B8628-5B5F-BCD5-F19C-A58558E858C9": {
   "name": "Slow Fall",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "4476C212-A776-CF84-67A6-5E79C77CB381": {
   "name": "Buck Riders",
   "type": "ability",
   "motion": "basic"
  },
  "0D0021D2-9945-8DB1-3C9F-C671D32DEB19": {
   "name": "Panic Switch",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "D48E7CE7-723B-EB02-2AB0-05C6301BC7E9": {
   "name": "Commander",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "403F2CB5-C54A-A2A2-F131-B2EAFFBD9C84": {
   "name": "Coat Oil of Sharpness",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "D6E1D328-1B24-6803-C76C-25A4F5800A64": {
   "name": "Apply Oil of Slipperiness",
   "type": "full_ability",
   "motion": "gesture"
  },
  "B80B9ED2-C7A8-2B2E-B762-AC70F1A9C84A": {
   "name": "Drink Antidote",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "1B9529D4-2519-A9E3-EEDC-7A313241EC51": {
   "name": "Drink Antitoxin",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "D33F3689-A344-A216-BE82-A6F99CE42EF0": {
   "name": "Apply Smelling Salt",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "268C3289-0D9C-0043-9194-E52F2E3ACCED": {
   "name": "Reactionary Reduce Damage (d10)",
   "type": "reaction_ability",
   "motion": "parry"
  },
  "BF296EE3-66E3-EA2B-AFBD-CC35EC7211CB": {
   "name": "Stop the Bleeding (2d6)",
   "type": "ability",
   "motion": "gesture"
  },
  "3C5C15AE-4B5C-5B97-7EEC-28086727048B": {
   "name": "Stop the Bleeding (3d6)",
   "type": "ability",
   "motion": "gesture"
  },
  "BABCFD5D-088F-BFD0-29E6-4A53195A08FD": {
   "name": "Basic First Aid",
   "type": "full_ability",
   "motion": "gesture"
  },
  "49079587-67C9-AA33-4752-5B7AA0011156": {
   "name": "Viral Checkup",
   "type": "full_ability",
   "motion": "gesture"
  },
  "4EEC473F-284E-9661-0D63-0729CB95227D": {
   "name": "Vaccination",
   "type": "full_ability",
   "motion": "gesture"
  },
  "9613A796-B203-0F32-687D-8FA96F005816": {
   "name": "Nimble Dash",
   "type": "quick_ability",
   "motion": "basic"
  },
  "01099AE6-1EFC-4680-B714-844F5188AD8D": {
   "name": "Balanced Opening",
   "type": "quick_ability",
   "motion": "stance"
  },
  "8E2819C0-3E5C-1D45-B2C1-8A57E18B20F1": {
   "name": "Spotter's Call",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "C8C5823E-5601-83EA-AB4A-A6B0B9D3FD63": {
   "name": "Pilfer",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "AAA159CC-D0F2-6B58-F3EB-8A7944506738": {
   "name": "Wear Flesh",
   "type": "ability",
   "motion": "basic"
  },
  "C93C9F5F-B105-4131-BAE3-361A10DEDB69": {
   "name": "Reel In",
   "type": "quick_ability",
   "motion": "gesture"
  },
  "C5ACAAF1-A1C8-B41F-6908-8E1DDB5969AD": {
   "name": "Gregarious Choir",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "F748E781-C87C-4F4B-9870-68D9BA6D9581": {
   "name": "Skitter",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "FBD36C08-39A4-4382-A002-A8AEED8E8F9A": {
   "name": "Bolt",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "E98524CB-F795-3A68-19E9-DDE5D27E7407": {
   "name": "Flurry of Claws",
   "type": "quick_ability",
   "motion": "basic"
  },
  "109D6E87-E3E2-FE14-754B-92ED1FC383BA": {
   "name": "Drowning Cacophony",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "8658F70E-4A36-58C2-D6A1-F6BDD1ACB1B3": {
   "name": "Burst of Empathy",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "C1D16122-F715-B374-BA84-C09173C38E4C": {
   "name": "Reflexive Dodge",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "33DF9F92-25F3-D7EF-4580-A7AAE06FC595": {
   "name": "Inspiring Chant",
   "type": "quick_ability",
   "motion": "battlecry"
  },
  "952066AA-0790-9B94-0D60-710E5A55DC69": {
   "name": "Modular Construction",
   "type": "ability",
   "motion": "gesture"
  },
  "BCCD15AB-7CC5-C8A2-D556-529E36E16B09": {
   "name": "Very Difficult Terrain",
   "type": "ability",
   "motion": "stance"
  },
  "B5E0C678-3AAF-AA5A-92DE-5F1D07DE719E": {
   "name": "I Think That's Mine",
   "type": "ability",
   "motion": "gesture"
  },
  "9123DE1D-07A4-96C7-7F39-A4713560CA59": {
   "name": "Studied Opening",
   "type": "quick_ability",
   "motion": "stance"
  },
  "60C4431A-8F90-CBF5-6DBB-5E75E285E371": {
   "name": "Voracious Consumption",
   "type": "ability",
   "motion": "basic"
  },
  "FA445E51-E129-FEA9-4B8C-6CE8DFEC0453": {
   "name": "Corrupting Kiss",
   "type": "ability",
   "motion": "gesture"
  },
  "2619BE72-89C8-0DEE-ACD5-AB3F7E63B839": {
   "name": "Hurling Grasp",
   "type": "ability",
   "motion": "gesture"
  },
  "F5C916A9-A018-7A64-4901-7A6504B50B92": {
   "name": "Discordant Note",
   "type": "reaction_ability",
   "motion": "battlecry"
  },
  "9010502C-3923-C043-E343-87AD013F0C4E": {
   "name": "Symmetrical Shot",
   "type": "quick_ability",
   "motion": "stance"
  },
  "309FC7F0-9644-D3DA-2669-8F2E5D6F5D0F": {
   "name": "Flash Evade",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "CFD0AB12-ACFC-FE80-8F27-BD7D5FF1DDA5": {
   "name": "Pursuit Flash",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "9586D201-C521-2AC3-6303-220E532F2D5D": {
   "name": "Pursuit Current",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "5D27CF4C-ADFC-A2E0-352D-D19E458D160A": {
   "name": "Uncatchable Turn",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "CD6CA186-69D2-9DE3-0F90-72096B708F5A": {
   "name": "Light Bullseye Lantern",
   "type": "full_ability",
   "motion": "gesture"
  },
  "D76632FE-D53F-C897-D706-D9B5471A66F5": {
   "name": "Light Brazier",
   "type": "full_ability",
   "motion": "gesture"
  },
  "FBB150CD-7783-A81B-60A2-A757FFC44C4F": {
   "name": "Light Candle Fixture",
   "type": "full_ability",
   "motion": "gesture"
  },
  "BD659DC9-EE94-EE5A-A82D-2DA42D803FEA": {
   "name": "Light Fireplace",
   "type": "full_ability",
   "motion": "gesture"
  },
  "CFF9256F-1525-D75F-B34A-00C404A8816F": {
   "name": "Warning Flutter",
   "type": "reaction_ability",
   "motion": "basic"
  },
  "5B43FC0D-9294-B8B8-EA21-CBD9240F5918": {
   "name": "Already Foreseen",
   "type": "reaction_ability",
   "motion": "gesture"
  },
  "8FCD92B8-4D4F-8BCE-D847-78E606FD47E7": {
   "name": "Crack of the Crimson Whip",
   "type": "ability",
   "motion": "smash"
  },
  "DD850FC4-F999-8EB7-FC96-9CEDCCD04CC9": {
   "name": "Greedy Smirk",
   "type": "ability",
   "motion": "gesture"
  },
  "4744CC19-87A9-41D7-9285-ABD36470EC81": {
   "name": "Short Rest",
   "type": "full_ability",
   "motion": "none"
  }
 }
}
